import React from "react";

import moment from "moment";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Toggle from "react-toggle";

import { isEnabled } from "utils/featureFlags";

import { ROLE_OPTIONS, ROLE_VALUES } from "containers/App/reducer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import NumericLabel from "react-pretty-numbers";

import { LineInput } from "components/Inputs/LineInput";
import Slider from "components/Inputs/Slider/ProjectSlider";
import SankeyChart from "components/Optimizer/SankeyChart";
import CapSlider from "components/Project/CapSlider";
import ProfitSlider from "components/Project/ProfitSlider";
import PieChart from "components/Project/PieChart";
import RadarChart from "components/Project/RadarChart";
import AdvancedDeploy from "components/Project/AdvancedDeploy";
import TinyBarChart from "components/Project/TinyBarChart";
import ExplainBarChart from "components/Project/ExplainBarChart";
import BarChart from "components/Project/BarChart";
import ImpactSlider from "components/Optimizer/ImpactSlider";
import CompareScenario from "components/Project/CompareScenario";
import DeployScenario from "components/Project/nDeployScenario";
import PredictionDriverToolTip from "components/Project/PredictionDriverToolTip";
import ProjectHeaderContainer from "containers/Project/ProjectHeader";

import AssumptionLegend from "components/Project/AssumptionLegend";

import RunItemContainer from "containers/View/Item/RunItem";
import RunViewContainer from "containers/View/Run";
import RunPlotContainer from "containers/RunPlot/RunPlot";
import { isShowSharingAndAssumptions } from "containers/Project/reducer";
import { checkValueWarning, getWarningMessage } from "containers/Setup/reducer";
import AcademicReviewDatasetContainer from "containers/CreateWizard/Academic/AcademicReviewDataset";

import WizardContainer from "containers/Wizard/Wizard";
import MonitoringContainer from "containers/Monitoring/Monitoring";
import MonitoringFeedbackContainer from "containers/Monitoring/MonitoringFeedback";

import ContinuousFrontierContainer from "containers/FrontierSliders/ContinuousFrontier";
import FrontierSlidersContainer from "containers/FrontierSliders/FrontierSliders";
import { FRONTIER_SLIDERS_VIEW } from "containers/FrontierSliders/FrontierSliders";

import ProjectDeploymentContainer from "containers/Deployments/ProjectDeployment";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import Waterfall from "components/Waterfall/Waterfall";

import ModelError from "components/Results/ModelError";

import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";
import { getIsMonitoringDemo, MONITOR_VIEW_MODES } from "containers/Monitoring/reducer";

import numeral from "numeral";

import RefreshIcon from "images/refreshB.svg";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

// TODO: Super lazy blocking the help chat

const RIGHT_PANEL_WIDTH = "500px";

export const PROJECT_MODES = {
  OVERALL: "Overall",
  DRILLDOWN: "Drilldown",
  VIEW_SEGMENTS: "View Subgroups"
};

const numberFormatParams = {
  shortFormat: true,
  shortFormatMinValue: 0,
  precision: 1,
  justification: "L",
  locales: "en-US"
};

export default class Project extends React.PureComponent {
  constructor(props) {
    super(props);

    const isContinuous =
      props &&
      props.optimized &&
      props.optimized.bestModel &&
      props.optimized.bestModel.metrics &&
      props.optimized.bestModel.metrics.overImpact !== undefined &&
      props.optimized.bestModel.metrics.underImpact !== undefined;

    this.state = {
      isRightOpen: false,
      isAFO: false,
      isEditSales: false,
      isEditMarketing: false,
      isEditSalesImpacts: false,
      isEditMarketingImpacts: false,
      isHideCustomValues: false,
      isSetup: false,
      timePeriod: { value: "Month", label: "Month" },
      drilldownColumn: undefined,
      setupSections: {},
      sharingOptions: {},
      recalibrate: {},
      isHistory: false,
      isCreating: false,
      isCompare: false,
      isCreatingScenario: false,
      userFilter: "All",
      isDeploy: false,
      isDeployScreen: false,
      isShowCurrentState: false,
      compareElement: isContinuous ? "Error Cost" : "Profit",
      scenarioName: props.userName ? props.userName + "'s Scenario" : "New Scenario"
    };
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  renderMonitorRetrain() {
    const { project, optimized, isMonitorRetrain, updateProjectSetting, retrainDataset, retrainProjectFromDataset } =
      this.props;

    const { isOnlyMonitor } = this.state;

    const dataset = retrainDataset ? retrainDataset : undefined;

    const isMonitorDatasetReady = dataset && dataset.outcome !== undefined && dataset.dataset_status == "DONE";

    return (
      <div id={"monitorRetrainModal"}>
        <Dialog show={isMonitorRetrain} onOpenChange={() => updateProjectSetting("isMonitorRetrain", false)}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>
                <div>
                  {isMonitorDatasetReady !== true
                    ? "Retrain from Monitor Data"
                    : "You have enough monitoring data to retrain frontiers"}
                </div>
              </DialogTitle>
            </DialogHeader>
            {isMonitorDatasetReady !== true ? (
              <div className={styles.loadingRetrain}>
                <div>{"Loading Data..."}</div>
                <div>{"This may take a few minutes"}</div>
                <LoadingIndicator />
              </div>
            ) : (
              <div className={styles.retrainBody}>
                <div className={styles.retrainHeader}>{"Monitoring Data Overview"}</div>
                <AcademicReviewDatasetContainer id={optimized.id} selectedDataset={dataset} isShow={true} isRetrain />
              </div>
            )}
            <DialogFooter>
              <Button type="secondary" onClick={() => updateProjectSetting("isMonitorRetrain", false)}>
                {"Close"}
              </Button>
              <Button
                type="primary"
                disabled={isMonitorDatasetReady !== true}
                onClick={() => {
                  retrainProjectFromDataset(dataset.id);
                  return updateProjectSetting("isMonitorRetrain", false);
                }}
              >
                {"Create New Frontier"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  renderAssumptionPanel() {
    const { approveAssumption, restoreAssumption, deleteAssumption, rerunSegment, viewAssumption, project, optimized } =
      this.props;

    const { isHistory } = this.state;

    const activeSegment =
      project &&
      project.segments &&
      project.settings &&
      project.settings.runId &&
      project.segments.filter((s) => s.job && s.job.job_id === project.settings.runId).length > 0
        ? project.segments.filter((s) => s.job && s.job.job_id === project.settings.runId)[0]
        : undefined;

    if (activeSegment === undefined) {
      return <div />;
    }

    const draftSetups = activeSegment.history.assumptions.filter((a) => a.status === "DRAFT");

    const historySetups = activeSegment.history.assumptions.filter((a) => a.status === "ACCEPTED");

    const shouldRerun = isSameSetup(activeSegment.assumption.data, optimized.setup.jobSetup) === false;

    const isOverallSegment = this.getIsOverallSegment();

    return (
      <div className={styles.rContent}>
        <div className={styles.rHeader}>
          <div className={styles.hOverflow}>{activeSegment.name === "" ? "Overall" : activeSegment.name}</div>
          {isOverallSegment ? (
            <div />
          ) : (
            <div className={styles.tHolder}>
              <span style={{ marginRight: "5px" }}>{"Show History"}</span>
              <Toggle
                defaultChecked={isHistory}
                icons={false}
                onChange={(e) =>
                  this.setState({
                    isHistory: e.target.checked
                  })
                }
              />
              <span className={isHistory ? styles.yPos : styles.nPos}>{isHistory ? "On" : "Off"}</span>
            </div>
          )}
        </div>
        <div className={styles.rightPanelBody}>
          <div className={styles.activeAssumption}>
            <div className={styles.assSubHeader}>
              {isOverallSegment ? "Overall Assumption" : "Approved Assumption"}
              {isOverallSegment || isSameSetup(activeSegment.assumption.data, optimized.setup) ? (
                <div className={styles.viewing} style={{ marginRight: "20px" }}>
                  {"Viewing"}
                </div>
              ) : (
                <Button
                  style={{ marginRight: "20px", fontWeight: "normal" }}
                  onClick={() => viewAssumption(activeSegment.assumption.data)}
                >
                  {"View"}
                </Button>
              )}
            </div>
            <div className={styles.assumptions}>
              {this.renderAssumptionsSetup(isOverallSegment ? optimized.setup : activeSegment.assumption.data)}
              {isOverallSegment ? (
                <div className={styles.segmentButtonHolder} style={{ marginTop: "10px" }}>
                  {"This is a weighted average of all segment assumptions"}
                </div>
              ) : (
                <div className={styles.segmentButtonHolder} style={{ marginTop: "10px" }}>
                  <Button
                    style={{ marginRight: "20px", whiteSpace: "nowrap" }}
                    onClick={() => rerunSegment(optimized.segmentId)}
                    disabled={shouldRerun === false}
                  >
                    {"Retrain Models"}
                  </Button>
                  {shouldRerun ? (
                    <div>{"Aible recommends retraining the models based on the assumption changes"}</div>
                  ) : (
                    <div>{"Same assumptions as current frontier"}</div>
                  )}
                </div>
              )}
            </div>
          </div>
          {isOverallSegment !== true && isHistory ? (
            <div className={styles.rBody}>
              <div className={styles.assSubHeader}>{"Previous Approved Assumptions"}</div>
              <div className={styles.assHolder}>
                {historySetups.length > 0 ? (
                  historySetups.map((a, k) => (
                    <div className={styles.assumptions} key={k}>
                      <div className={styles.assSubHeader} style={{ fontWeight: "normal", marginLeft: "0px" }}>
                        <div title={moment.utc(a.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}>
                          {"Applied " + moment.utc(a.created_date).local().fromNow()}
                        </div>
                        {isSameSetup(a.data, optimized.setup) ? (
                          <div className={styles.viewing}>{"Viewing"}</div>
                        ) : (
                          <Button onClick={() => viewAssumption(a.data)}>{"View"}</Button>
                        )}
                      </div>
                      {this.renderAssumptionsSetup(a.data, activeSegment.assumption.data)}
                      <div className={styles.butHolder}>
                        <div>
                          <div className={styles.uHeader}>{"REQUESTED BY:"}</div>
                          <div className={styles.aUser}>{a.created_by.fullname}</div>
                        </div>
                        <div style={{ marginLeft: "60px" }}>
                          <div className={styles.uHeader}>{"REQUESTED DATE:"}</div>
                          <div
                            className={styles.aUser}
                            title={moment.utc(a.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                          >
                            {moment.utc(a.created_date).local().fromNow()}
                          </div>
                        </div>
                      </div>
                      <div className={styles.segmentButtonHolder}>
                        <Button style={{ marginRight: "10px" }} onClick={() => restoreAssumption(a.id)}>
                          {"Restore"}
                        </Button>
                        <Button onClick={() => deleteAssumption(a.id)}>{"Delete"}</Button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>{"No new requests"}</div>
                )}
              </div>
            </div>
          ) : (
            <div className={styles.rBody}>
              <div className={styles.assSubHeader}>{"Pending Scenarios"}</div>
              <div className={styles.assHolder}>
                {draftSetups.length > 0 ? (
                  draftSetups.map((a, k) => (
                    <div className={styles.assumptions} key={k}>
                      <div className={styles.assSubHeader} style={{ fontWeight: "normal", marginLeft: "0px" }}>
                        <div title={moment.utc(a.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}>
                          {"Applied " + moment.utc(a.created_date).local().fromNow()}
                        </div>
                        {isSameSetup(a.data, optimized.setup) ? (
                          <div className={styles.viewing}>{"Viewing"}</div>
                        ) : (
                          <Button onClick={() => viewAssumption(a.data)}>{"View"}</Button>
                        )}
                      </div>
                      {this.renderAssumptionsSetup(a.data, activeSegment.assumption.data)}
                      <div className={styles.butHolder}>
                        <div>
                          <div className={styles.uHeader}>{"REQUESTED BY:"}</div>
                          <div className={styles.aUser}>{a.created_by.fullname}</div>
                        </div>
                        <div style={{ marginLeft: "60px" }}>
                          <div className={styles.uHeader}>{"REQUESTED DATE:"}</div>
                          <div
                            className={styles.aUser}
                            title={moment.utc(a.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                          >
                            {moment.utc(a.created_date).local().fromNow()}
                          </div>
                        </div>
                      </div>
                      <div className={styles.segmentButtonHolder}>
                        <Button onClick={() => approveAssumption(a.id)}>{"Approve"}</Button>
                        <Button onClick={() => deleteAssumption(a.id)}>{"Decline"}</Button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ marginLeft: "20px" }}>{"No new requests"}</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSharing() {
    const {
      addUserRoleToSegment,
      deleteUserRoleFromSegment,
      deleteUserFromProject,
      patchUserRoleSegment,
      updateProjectSetting,
      modelGroups,
      project,
      users,
      userName,
      isLoadingSharing
    } = this.props;

    const { sharingOptions } = this.state;

    const roleOptions = ROLE_OPTIONS;

    return (
      <div className={styles.rContent}>
        <div className={styles.rHeader}>{"Sharing and Permissions"}</div>
        <div className={styles.shareHolder}>
          {project &&
            project.segments &&
            project.segments.map((s, i) => {
              const subKey = s.id;

              const userKey = subKey + "-user";
              const roleKey = subKey + "-role";

              const roles = s.roles.filter((r) => s.conditions.length == 0 || r.role_type != "VIEWER");

              const sRoleOptions = roleOptions.filter(({ value }) => s.conditions.length == 0 || value != "VIEWER");

              const userRole =
                s.roles.filter((r) => r.role_user.fullname === userName).length > 0
                  ? s.roles.filter((r) => r.role_user.fullname === userName)[0].role_type
                  : undefined;

              const overallRole =
                project.roles && project.roles.filter((r) => r.role_user.fullname === userName).length > 0
                  ? project.roles.filter((r) => r.role_user.fullname === userName)[0].role_type
                  : undefined;

              return (
                <div className={styles.shareItem} key={i}>
                  <div className={styles.rSubHeader}>
                    {s.name === ""
                      ? project.segments.length > 1 && userRole === "OWNER"
                        ? "Add to All Subgroups"
                        : "Overall"
                      : s.name
                        ? s.name.replace("@@_@@Other@@_@@", "Other")
                        : s.name}
                  </div>
                  {sharingOptions[subKey] && sharingOptions[subKey].isEdit ? (
                    <div className={styles.userEdit}>
                      {overallRole === "OWNER" &&
                        (isLoadingSharing ? (
                          <div className={styles.loadingShare}>
                            {"Adding user... "}
                            <LoadingIndicator style={{ margin: "0px", marginLeft: "20px" }} />
                          </div>
                        ) : (
                          <div className={styles.userItem} style={{ marginBottom: "20px" }}>
                            <div className={styles.userName} style={{ overflow: "visible" }}>
                              <Select
                                options={
                                  users
                                    ? users
                                        .filter(
                                          (u) =>
                                            u.fullname === undefined ||
                                            userName === undefined ||
                                            u.fullname !== userName
                                        )
                                        .map((u) => ({
                                          label: u.fullname,
                                          value: u.id
                                        }))
                                    : []
                                }
                                ref={userKey}
                              />
                            </div>
                            <div className={styles.userRoleSelect}>
                              <Select options={sRoleOptions} defaultValue={sRoleOptions[0]} ref={roleKey} />
                            </div>
                            <Button
                              onClick={() => {
                                addUserRoleToSegment(
                                  s.id,
                                  this.refs[userKey].state.value.value,
                                  this.refs[roleKey].state.value.value
                                );

                                this.refs[userKey].state.value = undefined;
                                this.refs[roleKey].state.value = sRoleOptions[0];
                              }}
                            >
                              {"Invite"}
                            </Button>
                          </div>
                        ))}
                      {s.name === "" && project.segments.length > 1 ? (
                        <div />
                      ) : (
                        roles.map((r, i) => (
                          <div key={i} className={styles.userItem}>
                            <div className={styles.userName}>{r.role_user.fullname}</div>
                            {r.role_user.fullname === userName ? (
                              <div className={styles.lockedRole}>
                                {r.role_type ? r.role_type.toLowerCase() : r.role_type}
                              </div>
                            ) : (
                              <div className={styles.uItem}>
                                <div className={styles.userRoleSelect}>
                                  <Select
                                    options={sRoleOptions}
                                    defaultValue={ROLE_VALUES[r.role_type]}
                                    onChange={(val) => patchUserRoleSegment(r.id, val.value)}
                                  />
                                </div>
                                <Button onClick={() => deleteUserFromProject(r.role_user.id)}>{"Delete"}</Button>
                              </div>
                            )}
                          </div>
                        ))
                      )}
                      <Button
                        onClick={() =>
                          this.setState({
                            sharingOptions: {
                              ...sharingOptions,
                              [subKey]: {
                                ...sharingOptions[subKey],
                                isEdit: false
                              }
                            }
                          })
                        }
                      >
                        {"Done"}
                      </Button>
                    </div>
                  ) : s.name === "" && project.segments.length > 1 && userRole === "OWNER" ? (
                    <div>
                      <a
                        onClick={() =>
                          this.setState({
                            sharingOptions: {
                              ...sharingOptions,
                              [subKey]: {
                                ...sharingOptions[subKey],
                                isEdit: true
                              }
                            }
                          })
                        }
                      >
                        {"Add Users"}
                      </a>
                    </div>
                  ) : (
                    <div>
                      <span>{roles.length + " Collaborator" + (roles.length > 1 ? "s" : "")}</span>
                      {userRole === "OWNER" && (
                        <a
                          onClick={() =>
                            this.setState({
                              sharingOptions: {
                                ...sharingOptions,
                                [subKey]: {
                                  ...sharingOptions[subKey],
                                  isEdit: true
                                }
                              }
                            })
                          }
                          style={{ marginLeft: "5px" }}
                        >
                          {"Edit"}
                        </a>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
        <div className={styles.eFooter}>
          <Button onClick={() => updateProjectSetting("isSharing", false)}>{"Close Sharing"}</Button>
        </div>
      </div>
    );
  }

  renderExplain() {
    const { project, modelGroups, optimized } = this.props;
    const { isExplainConversion, isExplainResource } = this.state;

    const groups =
      modelGroups && modelGroups.drilldownValues
        ? modelGroups.drilldownValues.filter((v) => v.value !== "Overall")
        : [];

    const conversionRate = groups.map((v) => ({
      label: v.value,
      ["Conversion Rate"]: (
        (v.bestModel ? v.bestModel.maxIteration.averageWinRate * 100 : 0) -
        (v.setup ? (v.setup.truePositive / (v.setup.truePositive + v.setup.falsePositive)) * 100 : 0)
      ).toFixed(2)
    }));

    const resourceAllocation = groups.map((v) => ({
      label: v.value,
      ["Relative Resource Allocation"]: (((v.optimalPct - v.currentCost) / (v.currentCost / 2)) * 100).toFixed(2)
    }));

    return (
      <div className={styles.explain}>
        <div className={styles.eHeader}>{"Aible Compared to Current Strategy"}</div>
        {isExplainConversion ? (
          <div className={styles.eContent} style={{ padding: "20px" }}>
            <div className={styles.eMiniHeader} style={{ marginTop: "0px" }}>
              {"Conversion Rate Detail"}
            </div>
            <div className={styles.eLegend}>
              <div className={styles.eLegendItem}>
                <span className={styles.eLegendIcon} style={{ background: "#E0E0E0" }} />
                {"CURRENT STATE"}
              </div>
              <div className={styles.eLegendItem}>
                <span className={styles.eLegendIcon} style={{ background: "#7E69D7" }} />
                {"AIBLE"}
              </div>
            </div>
            {groups.map((v, i) => {
              const trueAction = v && v.setup && v.setup.trueAction ? v.setup.trueAction : "Pursued";
              const truePositiveLabel = v && v.setup ? v.setup.truePositiveLabel : "True Positive";

              const pursued = v && v.setup ? Number(v.setup.truePositive) + Number(v.setup.falsePositive) : 0;
              const aiblePursued =
                v && v.bestModel && v.bestModel.maxIteration
                  ? Number(v.bestModel.maxIteration.confusionMatrix.tp) +
                    Number(v.bestModel.maxIteration.confusionMatrix.fp)
                  : 0;

              const currentTruePositive = v && v.setup ? v.setup.truePositive : 0;
              const aibleTruePositive =
                v && v.bestModel && v.bestModel.maxIteration
                  ? v && v.bestModel && v.bestModel.maxIteration.confusionMatrix.tp
                  : 0;

              return (
                <div className={styles.eItemSub} key={i}>
                  <div className={styles.eItemHeader}>{v.value}</div>
                  <div className={styles.eSubItem}>{trueAction}</div>
                  <div className={styles.explainChart}>
                    <ExplainBarChart
                      bars={[
                        {
                          label: "Aible Optimized " + trueAction,
                          [trueAction]: aiblePursued
                        },
                        {
                          label: "Current " + trueAction,
                          [trueAction]: pursued
                        }
                      ]}
                      dKey={trueAction}
                      unit={optimized.unitLabelShort}
                    />
                    <div className={styles.aCounts}>
                      <div>{numeral(aiblePursued).format("0.0a")}</div>
                      <div>{numeral(pursued).format("0.0a")}</div>
                    </div>
                  </div>
                  <div className={styles.eSubItem}>{truePositiveLabel}</div>
                  <div className={styles.explainChart}>
                    <ExplainBarChart
                      bars={[
                        {
                          label: "Aible Optimized " + truePositiveLabel,
                          [truePositiveLabel]: aibleTruePositive
                        },
                        {
                          label: "Current " + truePositiveLabel,
                          [truePositiveLabel]: currentTruePositive
                        }
                      ]}
                      dKey={truePositiveLabel}
                    />
                    <div className={styles.aCounts}>
                      <div>{numeral(aibleTruePositive).format("0.0a")}</div>
                      <div>{numeral(currentTruePositive).format("0.0a")}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : isExplainResource ? (
          <div className={styles.eContent} style={{ padding: "20px" }}>
            <div className={styles.eMiniHeader} style={{ marginTop: "0px" }}>
              {"Resource Allocation Detail"}
            </div>
            <div className={styles.eLegend}>
              <div className={styles.eLegendItem}>
                <span className={styles.eLegendIcon} style={{ background: "#E0E0E0" }} />
                {"CURRENT STATE"}
              </div>
              <div className={styles.eLegendItem}>
                <span className={styles.eLegendIcon} style={{ background: "#7E69D7" }} />
                {"AIBLE"}
              </div>
            </div>
            {groups.map((v, i) => {
              const resourcingLabel = v && v.setup ? v.setup.advancedCostLabel : "Resourcing";
              const profitLabel = v && v.setup ? v.setup.netImpactLabel : "Profit";

              const currentResource = v ? v.currentCost : 0;
              const aibleResource = v ? v.optimalPct : 0;

              const currentProfit = v ? v.currentProfit : 0;
              const aibleProfit = v ? v.profit : 0;

              return (
                <div className={styles.eItemSub} key={i}>
                  <div className={styles.eItemHeader}>{v.value}</div>
                  <div className={styles.eSubItem}>{resourcingLabel}</div>
                  <div className={styles.explainChart}>
                    <ExplainBarChart
                      bars={[
                        {
                          label: "Aible Optimized " + resourcingLabel,
                          [resourcingLabel]: aibleResource
                        },
                        {
                          label: "Current " + resourcingLabel,
                          [resourcingLabel]: currentResource
                        }
                      ]}
                      dKey={resourcingLabel}
                      unit={optimized.unitLabelShort}
                    />
                    <div className={styles.aCounts}>
                      <div>{numeral(aibleResource).format("0.0a")}</div>
                      <div>{numeral(currentResource).format("0.0a")}</div>
                    </div>
                  </div>
                  <div className={styles.eSubItem}>{profitLabel}</div>
                  <div className={styles.explainChart}>
                    <ExplainBarChart
                      bars={[
                        {
                          label: "Aible Optimized " + profitLabel,
                          [profitLabel]: aibleProfit
                        },
                        {
                          label: "Current " + profitLabel,
                          [profitLabel]: currentProfit
                        }
                      ]}
                      dKey={profitLabel}
                    />
                    <div className={styles.aCounts}>
                      <div>{numeral(aibleProfit).format("0.0a")}</div>
                      <div>{numeral(currentProfit).format("0.0a")}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.eContent}>
            <div className={styles.eItem} style={{ marginTop: "0px" }}>
              <div className={styles.eMiniHeader}>{"Improved Conversion Rate"}</div>
              <div className={styles.eBody}>
                {"Aible's optimized AI did a better job of targeting the transactions that are most likely to convert."}
                <div>
                  <a onClick={() => this.setState({ isExplainConversion: true })}>{"Learn More"}</a>
                </div>
                <BarChart bars={conversionRate} unit={"%"} label={"Conversion Rate"} />
              </div>
            </div>
            <div className={styles.eItem} style={{ borderTop: "1px solid rgba(0, 0, 0, 0.2)" }}>
              <div className={styles.eMiniHeader}>{"Improved Relative Resource Allocation"}</div>
              <div className={styles.eBody}>
                {"Aible's reallocated the available resources more optimally across subgroups."}
                <div>
                  <a onClick={() => this.setState({ isExplainResource: true })}>{"Learn More"}</a>
                </div>
                <BarChart bars={resourceAllocation} unit={"%"} label={"Relative Resource Allocation"} />
              </div>
            </div>
          </div>
        )}
        <div
          className={styles.eFooter}
          style={
            isExplainResource || isExplainConversion
              ? {
                  justifyContent: "space-between",
                  marginLeft: "20px",
                  marginRight: "20px"
                }
              : {}
          }
        >
          <Button onClick={() => this.setState({ isExplain: false })}>{"Close Explanation"}</Button>
          {isExplainConversion || isExplainResource ? (
            <Button
              onClick={() =>
                this.setState({
                  isExplainConversion: false,
                  isExplainResource: false
                })
              }
            >
              {"Back to Overview"}
            </Button>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }

  renderFooterDeployScreen() {
    const { updateAibleViewType, isAFO } = this.props;
    const { isAdvancedDeploy } = this.state;

    return (
      <div
        className={styles.footerHolder}
        style={{
          width: isAFO ? "calc(100% - 500px)" : "100%",
          justifyContent: "center"
        }}
      >
        <div className={styles.fSection}>
          <Button
            onClick={() => {
              updateAibleViewType(AIBLE_VIEW_TYPE.BUSINESS);
              return this.setState({
                isDeploy: false,
                isAdvancedDeploy: false,
                isDeployScreen: false
              });
            }}
          >
            {"Back to Overview"}
          </Button>
        </div>
      </div>
    );
  }

  renderFooterDeploy() {
    const { deploy, updateAibleViewType, isAFO } = this.props;

    const { isAdvancedDeploy } = this.state;

    return (
      <div
        className={styles.footerHolder}
        style={{
          width: isAFO ? "calc(100% - 500px)" : "100%",
          justifyContent: "center"
        }}
      >
        <div className={styles.fSection}>
          <Button onClick={() => this.setState({ isDeploy: false, isAdvancedDeploy: false })}>
            {"Back to Overview"}
          </Button>
          <Button
            style={{ marginLeft: "10px" }}
            type={"primary"}
            onClick={() => {
              deploy();
              updateAibleViewType(AIBLE_VIEW_TYPE.DEPLOYMENT);
              this.setState({ isDeploy: false, isAdvancedDeploy: false });
            }}
          >
            {"Approve and Deploy New Strategy"}
          </Button>
        </div>
      </div>
    );
  }

  renderFooter() {
    const {
      allScenarios,
      project,
      optimized,
      modelGroups,
      viewScenario,
      deleteScenario,
      shortlistScenario,
      compareScenarioIndex,
      updateCompareScenarioIndex,
      updateShowPending,
      updateShowShortListed,
      selectedScenario,
      removeShortlist,
      saveScenario,
      isAFO,
      refresh,
      aibleViewType,
      showPending,
      showShortListed,
      viewingScenarioIndex,
      canEditSegments
    } = this.props;
    const {
      isCompare,
      isExplain,
      isDeploy,
      isDeployScreen,
      isAdvancedDeploy,
      isCreatingScenario,
      userFilter,
      typeFilter,
      scenarioName
    } = this.state;

    if (isDeploy || isAdvancedDeploy) {
      return this.renderFooterDeploy();
    }

    let hasSameScenario = false;

    const userOptions =
      project && project.roles
        ? project.roles.map((r) => ({
            label: r.role_user.fullname,
            value: r.role_user.id
          }))
        : [];

    const sOptions = [{ label: "All Users", value: "All" }].concat(userOptions);

    const typeOptions = [
      { label: "All Scenarios", value: "All" },
      { label: "Shortlisted", value: "Shortlisted" },
      { label: "Pending", value: "Pending" }
    ];

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    const isOnlyOverall = project && project.segments && project.segments.length <= 1;

    return (
      <div className={styles.footerHolder} style={{ width: isAFO ? "calc(100% - 500px)" : "100%" }}>
        <div className={styles.fSection}>
          {aibleViewType === AIBLE_VIEW_TYPE.BUSINESS && (
            <div style={{ marginRight: "10px" }}>
              <Button
                onClick={() => refresh()}
                style={
                  project && project.settings && project.settings.isRefreshing
                    ? {
                        height: "35px",
                        width: "51px",
                        position: "relative",
                        pointerEvents: "none"
                      }
                    : {}
                }
              >
                {project && project.settings && project.settings.isRefreshing ? (
                  <LoadingIndicator
                    color={"#333"}
                    style={{
                      height: "13px",
                      width: "13px",
                      margin: "0px",
                      position: "absolute",
                      transform: "scale(0.4)",
                      top: "0px",
                      left: "8px"
                    }}
                  />
                ) : (
                  <img src={RefreshIcon} style={{ height: "13px", width: "13px" }} />
                )}
              </Button>
            </div>
          )}
          <div className={styles.scenarioPicker} style={{ marginRight: "10px" }}>
            <Select
              options={typeOptions}
              value={
                typeOptions.filter((s) => s.value === typeFilter).length > 0
                  ? typeOptions.filter((s) => s.value === typeFilter)[0]
                  : { label: "All Scenarios", value: "All" }
              }
              menuPlacement={"top"}
              onChange={(val) => this.setState({ typeFilter: val.value })}
            />
          </div>
          <div className={styles.scenarioPicker}>
            <Select
              options={sOptions}
              value={
                sOptions.filter((s) => s.value === userFilter).length > 0
                  ? sOptions.filter((s) => s.value === userFilter)[0]
                  : { label: "All Users", value: "All" }
              }
              menuPlacement={"top"}
              onChange={(val) => this.setState({ userFilter: val.value })}
            />
          </div>
          {allScenarios ? (
            <ButtonGroup
              style={{
                marginLeft: "10px",
                maxWidth: "375px",
                overflowX: "auto"
              }}
            >
              {allScenarios
                .sort((a, b) => a.index - b.index)
                .filter((s) => s.scenario !== undefined)
                .map((s, i) => {
                  let isSameScenario = true;
                  Object.keys(s.scenario)
                    .filter((c, i, sList) => sList.length === 1 || i > 0 || true)
                    .sort((a, b) => (a === "Overall" ? -1 : b === "Overall" ? 1 : a < b ? -1 : 1))
                    .forEach((k, i, sList) => {
                      if (modelGroups.drilldownValues[i] === undefined) {
                        isSameScenario = false;
                      } else if (
                        isSameSetup(s.scenario[k].setup.data, modelGroups.drilldownValues[i].oSetup) === false
                      ) {
                        isSameScenario = false;
                      }
                    });

                  if (isSameScenario === true) {
                    hasSameScenario = true;
                  }

                  let shouldRender =
                    userFilter === "All" ||
                    (s.originalScenario &&
                      s.originalScenario.created_by &&
                      userFilter === s.originalScenario.created_by.id);

                  shouldRender =
                    shouldRender &&
                    (typeFilter === "Pending" && s.originalScenario.status === "PENDING" ? false : true);

                  shouldRender =
                    shouldRender &&
                    (typeFilter === "Shortlisted" && s.originalScenario.status === "DRAFT" ? false : true);

                  return !shouldRender ? (
                    <div key={i} />
                  ) : (
                    <OverlayTrigger
                      key={i}
                      placement="top"
                      trigger={["hover"]}
                      rootClose
                      overlay={
                        <Popover id="popover-positioned-top" title={s.originalScenario.name}>
                          <div className={styles.resoucePopup}>
                            <div className={styles.tooltipLine}>
                              <div>{"Created By"}</div>
                              <div>{s.originalScenario.created_by.fullname}</div>
                            </div>
                            <div className={styles.tooltipLine}>
                              <div>{"Created On"}</div>
                              <div>
                                {moment.utc(s.originalScenario.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
                              </div>
                            </div>
                            <div className={styles.tooltipLine}>
                              <div>{"Status"}</div>
                              <div>{s.originalScenario.status}</div>
                            </div>
                          </div>
                        </Popover>
                      }
                    >
                      <Button
                        className={styles.footerBtn}
                        key={i}
                        onClick={isCompare ? () => updateCompareScenarioIndex(i) : () => viewScenario(s.scenario, i)}
                        onMouseOver={
                          isCompare && compareScenarioIndex !== i ? () => updateCompareScenarioIndex(i) : () => {}
                        }
                        active={
                          isCompare
                            ? false
                            : (s && viewingScenarioIndex === s.index) ||
                              isSameScenario ||
                              (isCompare && compareScenarioIndex === i)
                        }
                        style={
                          isCompare && viewingScenarioIndex === s.index
                            ? { border: "2px solid rgb(239, 126, 84)" }
                            : isCompare && compareScenarioIndex === s.index
                              ? { border: "2px solid rgb(126, 105, 215)" }
                              : {}
                        }
                      >
                        {s.originalScenario ? s.originalScenario.name : i}
                      </Button>
                    </OverlayTrigger>
                  );
                })}
              <Button disabled={hasSameScenario} active={hasSameScenario === false}>
                {"New"}
              </Button>
            </ButtonGroup>
          ) : (
            <div />
          )}
          {hasSameScenario ? (
            <div />
          ) : (
            <div className={styles.nameInput}>
              <LineInput
                isMediumBox
                defaultValue={scenarioName}
                onChange={(val) => this.setState({ scenarioName: val })}
              />
            </div>
          )}
          <ButtonGroup>
            <Button
              disabled={hasSameScenario || isCreatingScenario}
              style={{ marginLeft: "10px" }}
              type={"primary"}
              onClick={() => {
                this.setState({ isCreatingScenario: true });
                setTimeout(() => this.setState({ isCreatingScenario: false }), 5000);
                setTimeout(() => saveScenario(scenarioName), 1);
              }}
            >
              {"Save"}
            </Button>
            {selectedScenario &&
            selectedScenario.originalScenario &&
            selectedScenario.originalScenario.status === "PENDING" ? (
              <Button disabled={!canEditSegments} onClick={() => removeShortlist()}>
                {"Remove Shortlist"}
              </Button>
            ) : (
              <Button
                disabled={
                  !canEditSegments ||
                  (selectedScenario &&
                  selectedScenario.originalScenario &&
                  selectedScenario.originalScenario.status === "DRAFT" &&
                  hasSameScenario === true
                    ? false
                    : true)
                }
                type={"primary"}
                onClick={() => shortlistScenario()}
              >
                {"Shortlist"}
              </Button>
            )}
            <Button onClick={() => deleteScenario()}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </ButtonGroup>
        </div>
        <div className={styles.fSection}>
          {isCompare !== true && !isContinuous && (
            <Button
              onClick={() => this.setState({ isCompare: !isCompare })}
              disabled={selectedScenario === undefined || allScenarios.length < 2}
              active={isCompare}
            >
              {isCompare ? "Back to Aible Business" : "Compare"}
            </Button>
          )}
          <Button
            style={{ marginLeft: "10px" }}
            type={"primary"}
            disabled={
              optimized.isCreating ||
              hasSameScenario === false ||
              selectedScenario === undefined ||
              selectedScenario.originalScenario.status === "DRAFT"
            }
            onClick={() => this.setState({ isCompare: false, isDeploy: !isDeploy })}
          >
            {selectedScenario === undefined || selectedScenario.originalScenario.status === "DRAFT"
              ? "Shortlist Scenario to Deploy"
              : "Deploy Strategy"}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const {
      optimizer,
      optimized,
      activeSegment,
      project,
      selectRun,
      history,
      modelGroups,
      segmentOptions,
      isMonitorFeedback,
      runs,
      match,
      isAFO,
      handleCreateDrilldown,
      updateDrilldownValue,
      isSharing,
      rerunSegment,
      setFirstRunId,
      setSecondRunId,
      updateAibleViewType,
      projectMode,
      updateProjectMode
    } = this.props;
    const {
      mode,
      isEditSales,
      isEditMarketing,
      isRightOpen,
      isDeploy,
      isAdvancedDeploy,
      isDeployScreen,
      isAssumptions,
      isExplain,
      timePeriod,
      drilldownColumn,
      isSetup,
      isCompare
    } = this.state;

    const aibleViewType = optimizer && optimizer.aibleViewType;

    if (optimized === undefined || optimized.isLoading) {
      return (
        <div className={styles.optimizer}>
          <div className={styles.loading}>
            <LoadingIndicator
              style={{
                margin: "0px",
                marginTop: "-20%",
                marginBottom: "50px",
                transform: "scale(1.75)"
              }}
            />
            <div className={styles.loadMsg}>{"Loading project..."}</div>
          </div>
        </div>
      );
    }

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    const isOverallSegmentWithSplits =
      optimized && optimized.overallSegmentId == optimized.segmentId && project.segments.length > 1;

    if (match && match.params && match.params.isBusiness && match.params.isBusiness === "one") {
      return (
        <WizardContainer
          projectId={project ? project.id : undefined}
          id={optimized.id}
          isConsumerMode
          isPreviewMode
          activeSegment={optimized ? optimized.activeSegment : undefined}
          isOverallSegment={isOverallSegmentWithSplits}
          modelGroups={modelGroups}
          segmentOptions={segmentOptions}
          optimizer={optimizer}
          updateDrilldownValue={updateDrilldownValue}
        />
      );
    }

    return (
      <div className={styles.optimizer}>
        {this.renderMonitorRetrain()}
        {aibleViewType === AIBLE_VIEW_TYPE.BUSINESS && optimized.isLoading !== true && optimized.isCreating !== true ? (
          this.renderFooter()
        ) : aibleViewType === AIBLE_VIEW_TYPE.MONITORING || aibleViewType === AIBLE_VIEW_TYPE.DEPLOYMENT ? (
          this.renderFooterDeployScreen()
        ) : (
          <div />
        )}
        <div className={styles.aibleForOne} style={{ width: isAFO ? RIGHT_PANEL_WIDTH : "0px" }}>
          {isAFO && (
            <WizardContainer
              projectId={project ? project.id : undefined}
              id={optimized.id}
              isConsumerMode
              isPreviewMode
              activeSegment={optimized ? optimized.activeSegment : undefined}
              isOverallSegment={isOverallSegmentWithSplits}
              modelGroups={modelGroups}
              segmentOptions={segmentOptions}
              optimizer={optimizer}
              updateDrilldownValue={updateDrilldownValue}
            />
          )}
        </div>
        <div
          className={styles.rightP}
          style={{
            width: isSharing ? RIGHT_PANEL_WIDTH : "0px",
            marginTop: "0px",
            height: "calc(100% - 60px)"
          }}
        >
          {isSharing && this.renderSharing()}
        </div>
        <div
          className={styles.rightP}
          style={{
            width: isExplain ? RIGHT_PANEL_WIDTH : "0px",
            height: "calc(100% - 60px)",
            marginTop: "0px"
          }}
        >
          {isExplain && this.renderExplain()}
        </div>
        <div
          className={styles.pBody}
          style={{
            width: isAFO || isExplain || isSharing ? "calc(100% - 500px)" : "100%"
          }}
        >
          {isDeploy || isCompare ? (
            <div />
          ) : (
            <ProjectHeaderContainer
              id={project ? project.id : undefined}
              blueprintId={optimized ? optimized.blueprintId : undefined}
              runId={optimized ? optimized.id : undefined}
            />
          )}
          {projectMode === PROJECT_MODES.VIEW_SEGMENTS ? (
            <RunViewContainer
              hideFirstTile
              hideShowMore
              projectId={project.id}
              projectUpdateView={() => updateProjectMode(PROJECT_MODES.OVERALL)}
            />
          ) : aibleViewType === AIBLE_VIEW_TYPE.MONITORING ? (
            isMonitorFeedback ? (
              <MonitoringFeedbackContainer id={project.id} />
            ) : (
              <MonitoringContainer id={project.id} />
            )
          ) : aibleViewType === AIBLE_VIEW_TYPE.DEPLOYMENT ? (
            <ProjectDeploymentContainer id={project && project.id} />
          ) : aibleViewType === AIBLE_VIEW_TYPE.ADVANCED ? (
            <WizardContainer id={optimized.id} projectId={project ? project.id : undefined} />
          ) : aibleViewType === AIBLE_VIEW_TYPE.BUSINESS ? (
            isDeploy ? (
              <DeployScenario {...this.props} />
            ) : isCompare ? (
              <CompareScenario {...this.props} onClose={() => this.setState({ isCompare: false })} />
            ) : (
              <React.Fragment>
                {!isOverallSegmentWithSplits && optimized.errors && optimized.errors.length > 0 ? (
                  <div className={styles.optimizerEmpty}>
                    <ModelError errors={optimized.errors} aibleViewType={aibleViewType} />
                    <div className={styles.retrain}>
                      <Button onClick={() => rerunSegment(optimized.segmentId)}>{"Retrain Frontier"}</Button>
                    </div>
                  </div>
                ) : optimized.isLoading || optimized.isCreating ? (
                  <div className={styles.optimizerEmpty}>
                    <div className={styles.loading}>
                      <LoadingIndicator
                        style={{
                          margin: "0px",
                          marginTop: "-20%",
                          marginBottom: "50px",
                          transform: "scale(1.75)"
                        }}
                      />
                      <div className={styles.loadMsg}>
                        {optimized.isCreating ? "Generating frontier..." : "Loading frontier..."}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>{isContinuous ? this.renderContinuous() : this.renderOverall()}</div>
                )}
              </React.Fragment>
            )
          ) : (
            ""
          )}
        </div>
        {this.renderRightPanel()}
      </div>
    );
  }

  renderProfitBox(style, hideButton = false) {
    const { project, optimized, optimizer, modelGroups, optimalProfit, optimalCost } = this.props;

    const { isExplain } = this.state;

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    const isOnlyOverall = project && project.segments && project.segments.length <= 1;

    return (
      <div className={styles.mItemMid + " " + styles.dropShadow} style={{ ...style }}>
        <div className={styles.newItemHeader}>{"Aible Optimized " + optimized.profitLabel}</div>
        {optimized.isCreatingSplit ? (
          <div className={styles.newOItemContent}>
            <LoadingIndicator style={{ marginTop: "-20px" }} />
            <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
          </div>
        ) : (
          <div className={styles.newOItemContent}>
            <div className={styles.cHero}>
              {optimized.isCurrencyUnitType ? (
                <div className={styles.sHero}>
                  {optimized.unitLabel}
                  {numeral(optimized.profit).format("0.0a")}
                </div>
              ) : (
                <div className={styles.sHero} style={{ display: "block" }}>
                  {numeral(optimized.profit).format("0.0a")}
                  <div className={styles.subLabel}>{optimized.unitLabel}</div>
                </div>
              )}
            </div>
            <TinyBarChart
              bars={[
                {
                  label: "Optimal " + optimized.profitLabel,
                  Cost: optimized.profit
                },
                {
                  label: "Current " + optimized.profitLabel,
                  Cost: optimized.currentProfit
                }
              ]}
              unit={optimized.unitLabel}
              isCurrencyUnit={optimized.isCurrencyUnitType}
              warning={
                false ? (
                  <OverlayTrigger
                    placement="bottom"
                    trigger={["hover"]}
                    rootClose
                    overlay={
                      <Popover id="popover-positioned-top" title={"Resourcing Not Optimal"}>
                        <div className={styles.resoucePopup}>
                          {"At the optimal resourcing of " +
                            numeral(optimalCost).format("0.0a") +
                            " " +
                            optimized.resourcingLabel +
                            " you would get " +
                            numeral(optimalProfit).format("0.0a") +
                            " " +
                            optimized.profitLabel}
                        </div>
                      </Popover>
                    }
                  >
                    <div className={styles.warningHolder}>
                      <FontAwesomeIcon icon={faExclamationTriangle} />
                    </div>
                  </OverlayTrigger>
                ) : undefined
              }
            />
            {!isOnlyOverall && !isContinuous && (
              <a onClick={() => this.setState({ isExplain: !isExplain })} className={styles.learnWhy}>
                {"Learn Why"}
              </a>
            )}
          </div>
        )}
      </div>
    );
  }

  renderContinuous() {
    const {
      optimized,
      optimizer,
      project,
      dataset,
      createSplits,
      modelGroups,
      groupInfo,
      scaledTotal,
      isBusinessReality,
      setMinBudget,
      setMaxBudget,
      isAFO,
      isSharing,
      setSalesBudget,
      updateDrilldownValue,
      updateInnerId,
      updateIsBusinessReality,
      updateExpectedCountContinuous,
      updateExpectedValueContinuous,
      updateTruePositive,
      updateProjectSetting,
      updateTrueNegative,
      updateFalsePositive,
      updateFalseNegative,
      updateConversionGain,
      updateConversionCost,
      updateConversionMissed,
      updateConversionSaved,
      updateScaledTotal,
      updateOutcomePercentage,
      updateCustomValue,
      segmentOptions,
      canManageSegmentPermissions
    } = this.props;

    const {
      isExplain,
      isCreating,
      isEditMarketing,
      isEditSales,
      isEditMarketingImpacts,
      isEditSalesImpacts,
      isAssumptions,
      isHideCustomValues
    } = this.state;

    const isOverallSegment = this.getIsOverallSegment();
    const canEditAssumptions =
      optimizer.drilldownValue === "Overall" ||
      (segmentOptions &&
        segmentOptions.some((s) => s.value === optimizer.drilldownValue && s.runId === optimized.innerId));

    const retIsBusinessReality = !canEditAssumptions || optimized.isBusinessReality !== false;

    const topDrivers =
      modelGroups &&
      modelGroups.topDrivers &&
      modelGroups.topDrivers &&
      modelGroups.topDrivers.filter((m) => m.drilldownValue === optimizer.drilldownValue).length > 0
        ? modelGroups.topDrivers.filter((m) => m.drilldownValue === optimizer.drilldownValue)[0]
        : undefined;

    let mTotal = 0;
    if (groupInfo.marketing[optimizer.drilldownValue]) {
      Object.keys(groupInfo.marketing[optimizer.drilldownValue]).forEach((v) => {
        mTotal += groupInfo.marketing[optimizer.drilldownValue][v].cost;
      });
    }

    const hasCustomValues =
      optimized &&
      optimized.setup &&
      optimized.setup.customValues &&
      Object.keys(optimized.setup.customValues).length > 0;

    const showCustomValues = isHideCustomValues !== true && hasCustomValues;

    const splitOptions =
      optimized && optimized.dataset
        ? Object.keys(optimized.dataset.fields)
            .filter((f) => optimized.dataset.fields[f].type === "categorical" && f !== optimized.dataset.outcome)
            .filter((f) =>
              optimized && optimized.setup && optimized.setup.ignored && optimized.setup.ignored[f] ? false : true
            )
            .map((f) => ({
              label: optimized.dataset.fields[f].label,

              value: optimized.dataset.fields[f].label
            }))
        : [];

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];

    let drilldownSlice = undefined;

    for (let value of drilldownValues) {
      if (
        value.value != "Overall" &&
        (optimizer.drilldownValue == "Overall" || value.value === optimizer.drilldownValue)
      ) {
        drilldownSlice = value;
        break;
      }
    }

    const otherSlices = drilldownSlice
      ? drilldownValues.filter((v) => v && v.column && v.column == drilldownSlice.column && v.column !== "Overall")
      : undefined;

    let loadingSplits = false;

    otherSlices &&
      otherSlices.forEach((v) => {
        if (v.bestModel === undefined) {
          loadingSplits = true;
        }
      });

    const isEditCounts = !false;

    return (
      <div className={styles.overall}>
        <div
          className={styles.overallSection}
          style={{
            marginTop: "0px",
            paddingTop: "20px",
            width: isAFO || isExplain || isSharing ? "calc(100% - 500px)" : "100%"
          }}
        >
          <div className={styles.overallSectionBackground} />
          <div className={styles.mItem}>
            <div className={styles.mItemMid + " " + styles.dropShadow}>
              <div className={styles.newItemHeader + " " + styles.subBackground}>{"Optimal Mix"}</div>
              <div className={styles.newOItemContent} style={{ overflow: "visible" }}>
                {project && project.segments && project.segments.length === 1 && isCreating !== true ? (
                  <div className={styles.splitFieldHolder}>
                    <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
                      {"Split on Field"}
                    </div>
                    <div className={styles.splitField}>
                      <Select options={splitOptions} ref="splitOne" />
                    </div>
                    <Button
                      onClick={() => {
                        this.setState({ isCreating: true });
                        setTimeout(() => this.setState({ isCreating: false }), 5000);
                        createSplits(
                          this.refs["splitOne"].state.value !== null
                            ? this.refs["splitOne"].state.value.value
                            : undefined
                        );
                      }}
                    >
                      {"Create Subgroups"}
                    </Button>
                  </div>
                ) : loadingSplits || isCreating ? (
                  <div className={styles.smallLoader} style={{ padding: "2vw" }}>
                    <LoadingIndicator style={{ marginTop: "-20px" }} />
                    <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                  </div>
                ) : (
                  <div>
                    <div className={styles.pieHolder}>
                      <PieChart
                        secondaryColors
                        pData={
                          otherSlices
                            ? otherSlices.map((s) => ({
                                name: s.value,
                                runId: s.runId,
                                value: Math.abs(
                                  Math.round(s.bestModel.metrics.overImpact + s.bestModel.metrics.underImpact)
                                ),
                                color: s.value === optimizer.drilldownValue ? "#F47C20" : s.color
                              }))
                            : []
                        }
                        onClick={(runId, name) => updateDrilldownValue(runId, name)}
                        unit={optimized.unitLabelShort}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.mItem}>
            <div className={styles.bHeaderHolder}>
              <div className={styles.mItemMid + " " + styles.dropShadow}>
                <div className={styles.newItemHeader + " " + styles.subBackground}>
                  {"Optimized " + optimized.underestimateLabel + " Cost"}
                </div>
                {optimized.isCreatingSplit ? (
                  <div className={styles.newOItemContent}>
                    <LoadingIndicator style={{ marginTop: "-20px" }} />
                    <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                  </div>
                ) : (
                  <div className={styles.newOItemContent}>
                    <div className={styles.cHero}>
                      {optimized.unitLabelShort}
                      {optimized ? numeral(optimized.underEstimate).format("0.0a") : <div />}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.mItem}>
            <div className={styles.bHeaderHolder}>
              <div className={styles.mItemMid + " " + styles.dropShadow}>
                <div className={styles.newItemHeader + " " + styles.subBackground}>
                  {"Optimized " + optimized.overestimateLabel + " Cost"}
                </div>
                {optimized.isCreatingSplit ? (
                  <div className={styles.newOItemContent}>
                    <LoadingIndicator style={{ marginTop: "-20px" }} />
                    <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                  </div>
                ) : (
                  <div className={styles.newOItemContent}>
                    <div className={styles.cHero}>
                      {optimized.unitLabelShort}
                      {optimized ? numeral(optimized.overEstimate).format("0.0a") : <div />}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.mItem}>
            <div className={styles.bHeaderHolder}>
              <div className={styles.mItemMid + " " + styles.dropShadow}>
                <div className={styles.newItemHeader}>{"Aible Optimized Error Cost"}</div>
                {optimized.isCreatingSplit ? (
                  <div className={styles.newOItemContent}>
                    <LoadingIndicator style={{ marginTop: "-20px" }} />
                    <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                  </div>
                ) : (
                  <div className={styles.newOItemContent}>
                    <div className={styles.cHero}>
                      {optimized.unitLabelShort}
                      {optimized ? numeral(optimized.overEstimate + optimized.underEstimate).format("0.0a") : <div />}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.midHolder} style={{ marginTop: "240px" }}>
          <div className={styles.midBody}>
            <ContinuousFrontierContainer id={project && project.id} />
          </div>
          <div className={styles.newBottomContent}>
            <div className={styles.bottomPanel} style={{ marginTop: "20px" }}>
              <div className={styles.nItemBotHolder}>
                <div className={styles.nItemBotItem}>
                  <div className={styles.nItemBotHeader}>
                    {"Key Drivers"}
                    <PredictionDriverToolTip />
                  </div>
                  <div className={styles.oItemBotContent} style={{ marginTop: "6px" }}>
                    {optimized.activeSegment.conditions.length === 0 &&
                    project &&
                    project.segments &&
                    project.segments.length > 1
                      ? modelGroups.topDrivers.filter((s, i) => i > 0).map((s) => this.renderDrivers(s, 4, false))
                      : this.renderDrivers(modelGroups.activeDriver, 5, true)}
                  </div>
                </div>
                <div className={styles.nRight}>
                  <div className={styles.legendHolder}>
                    <div className={styles.legendTitle}>{"Assumptions"}</div>
                    <AssumptionLegend
                      data={modelGroups.drilldownValues}
                      innerId={optimized.innerId}
                      updateDrilldownValue={(runId, name) => {
                        if (name === "Overall") {
                          this.setState({
                            isEditMarketingImpacts: false
                          });
                        }
                        return updateInnerId(runId);
                      }}
                    />
                  </div>
                  <div className={styles.nItemRightHolder}>
                    {isOverallSegment === false ? (
                      <div className={styles.nItemBotHelp}>
                        <div className={styles.nHeaderHelp}>
                          {"Business Drivers"}
                          {isEnabled("aible-for-business-advanced-assumptions") && hasCustomValues && (
                            <div className={styles.customValueToggle}>
                              <Button
                                style={{ fontWeight: "normal" }}
                                active={isHideCustomValues === true}
                                onClick={() =>
                                  this.setState({
                                    isHideCustomValues: !isHideCustomValues
                                  })
                                }
                                isSmall
                              >
                                {"Advanced"}
                              </Button>
                            </div>
                          )}
                        </div>
                        {showCustomValues ? (
                          <div>
                            <div className={styles.shareHeader}>
                              <div className={styles.costEditThirdsOne} style={{ paddingLeft: "0px" }}>
                                {"Measure"}
                              </div>
                              <div className={styles.costEditThirdsTwo}>{"Current"}</div>
                              <div className={styles.costEditThirdsThree}>{"Expected (New)"}</div>
                            </div>
                            <div className={styles.aHolder}>
                              {Object.keys(optimized.setup.customValues).map((v, i) => {
                                const showWarning = checkValueWarning(
                                  optimized.setup.customValues[v],
                                  optimized.originalSetup.customValues[v]
                                );

                                const bpDesc =
                                  optimized &&
                                  optimized.blueprint &&
                                  optimized.blueprint &&
                                  optimized.blueprint.wizard &&
                                  optimized.blueprint.wizard.customFields &&
                                  optimized.blueprint.wizard.customFields[v] &&
                                  optimized.blueprint.wizard.customFields[v].desc
                                    ? optimized.blueprint.wizard.customFields[v].desc
                                    : v;
                                return (
                                  <React.Fragment>
                                    <div key={v + i} className={styles.assumptionEditItem}>
                                      <div className={styles.costEditThirdsOne} title={bpDesc}>
                                        {v}
                                      </div>
                                      <div className={styles.costEditThirdsTwo}>
                                        {optimized.originalSetup.customValues[v]}
                                      </div>
                                      <div className={styles.costEditThirdsThree}>
                                        <LineInput
                                          isMediumBox
                                          value={optimized.setup.customValues[v]}
                                          onChange={(val) =>
                                            updateCustomValue(optimized.innerId, optimized.setup.blueprintId, v, val)
                                          }
                                          isLocked={!canEditAssumptions}
                                          isWarning={showWarning}
                                          warning={
                                            showWarning &&
                                            getWarningMessage(
                                              optimized.setup.customValues[v],
                                              optimized.originalSetup.customValues[v]
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </React.Fragment>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className={styles.shareHeader}>
                              <div className={styles.costEditOne} style={{ paddingLeft: "0px" }}>
                                {"Measure"}
                              </div>
                              <div className={styles.costEditOne}>{"Expected"}</div>
                            </div>
                            <div className={styles.assumptionEditItem}>
                              <div className={styles.costEditOne}>{"Overestimate Cost"}</div>
                              <div className={styles.costEditOne}>
                                <LineInput
                                  isMediumBox
                                  value={Math.abs(optimized.setup.conversionGain)}
                                  onChange={(val) =>
                                    updateConversionGain(
                                      optimized.innerId,
                                      optimized.setup.conversionGain < 0 ? -1 * val : val
                                    )
                                  }
                                  isLocked={!canEditAssumptions}
                                />
                              </div>
                            </div>
                            <div className={styles.assumptionEditItem}>
                              <div className={styles.costEditOne}>{"Underestimate Cost"}</div>
                              <div className={styles.costEditTwo}>
                                <LineInput
                                  isMediumBox
                                  value={Math.abs(optimized.setup.conversionCost)}
                                  onChange={(val) =>
                                    updateConversionCost(
                                      optimized.innerId,
                                      optimized.setup.conversionCost < 0 ? -1 * val : val
                                    )
                                  }
                                  isLocked={!canEditAssumptions}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className={styles.nItemBotHelp}>
                        <div className={styles.nHeaderHelp} style={{ paddingLeft: "5px" }}>
                          {"Business Drivers"}
                          {isOverallSegment ? (
                            <span />
                          ) : (
                            <FontAwesomeIcon
                              className={styles.editIcon}
                              icon={faEdit}
                              onClick={() => this.setState({ isEditMarketingImpacts: true })}
                            />
                          )}
                          {isEnabled("aible-for-business-advanced-assumptions") && hasCustomValues && (
                            <div className={styles.customValueToggle}>
                              <Button
                                style={{ fontWeight: "normal" }}
                                active={isHideCustomValues === true}
                                onClick={() =>
                                  this.setState({
                                    isHideCustomValues: !isHideCustomValues
                                  })
                                }
                                isSmall
                              >
                                {"Advanced"}
                              </Button>
                            </div>
                          )}
                        </div>
                        <div className={styles.shareHeader}>
                          <div className={styles.costSectionOne} style={{ paddingLeft: "0px" }}>
                            {"Measure"}
                          </div>
                          <div className={styles.costSectionTwo}>{"Distribution"}</div>
                          <div className={styles.costSectionThree} style={{ paddingRight: "0px" }}>
                            {"Average"}
                          </div>
                        </div>
                        {showCustomValues ? (
                          <div
                            className={styles.oItemBotContent}
                            style={{
                              marginTop: "0px"
                            }}
                          >
                            <div className={styles.aholder}>
                              {Object.keys(optimized.setup.customValues).map((c, i) => (
                                <div key={i} className={styles.assumptionItem}>
                                  <div className={styles.costSectionOne} title={c}>
                                    {c}
                                  </div>
                                  <div className={styles.costSectionTwo}>
                                    <ImpactSlider
                                      impacts={modelGroups.drilldownValues.map((v) => ({
                                        value: v.setup.customValues[c],
                                        drilldownValue: v.value,
                                        runId: v.runId
                                      }))}
                                      currentImpact={optimized.setup.customValues[c]}
                                      drilldownValue={optimizer.drilldownValue}
                                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                                    />
                                  </div>
                                  <div className={styles.costSectionThree}>
                                    {optimized.setup.customValues[c] !== undefined
                                      ? Number(optimized.setup.customValues[c]).toFixed(2)
                                      : ""}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <div>
                            {modelGroups && modelGroups.drilldownValues && (
                              <div
                                className={styles.oItemBotContent}
                                style={{
                                  marginTop: "0px"
                                }}
                              >
                                <div className={styles.assumptionItem}>
                                  <div className={styles.costSectionOne}>{"Overestimate Cost"}</div>
                                  <div className={styles.costSectionTwo}>
                                    <ImpactSlider
                                      impacts={modelGroups.drilldownValues.map((v) => ({
                                        value: v.setup.conversionGain,
                                        drilldownValue: v.value,
                                        runId: v.runId
                                      }))}
                                      currentImpact={optimized.setup.conversionGain}
                                      drilldownValue={optimizer.drilldownValue}
                                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                                    />
                                  </div>
                                  <div className={styles.costSectionThree}>
                                    {optimized.setup.conversionGain !== undefined
                                      ? Math.abs(Number(optimized.setup.conversionGain)).toFixed(2)
                                      : ""}
                                  </div>
                                </div>
                                <div className={styles.assumptionItem}>
                                  <div className={styles.costSectionOne}>{"Underestimate Cost"}</div>
                                  <div className={styles.costSectionTwo}>
                                    <ImpactSlider
                                      impacts={modelGroups.drilldownValues.map((v) => ({
                                        value: v.setup.conversionCost,
                                        drilldownValue: v.value,
                                        runId: v.runId
                                      }))}
                                      currentImpact={optimized.setup.conversionCost}
                                      drilldownValue={optimizer.drilldownValue}
                                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                                    />
                                  </div>
                                  <div className={styles.costSectionThree}>
                                    {optimized.setup.conversionCost !== undefined
                                      ? Math.abs(Number(optimized.setup.conversionCost)).toFixed(2)
                                      : ""}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    <div className={styles.nItemBotHelp}>
                      {isOverallSegment ? (
                        <div className={styles.nHeaderHelp}>&nbsp;</div>
                      ) : (
                        <div className={styles.nHeaderHelp}>
                          {"Will future behavior match the current state?"}
                          <span
                            style={{
                              marginLeft: "10px",
                              position: "relative",
                              flexShrink: "0"
                            }}
                          >
                            <div>
                              <Toggle
                                checked={retIsBusinessReality}
                                icons={false}
                                onChange={(e) => {
                                  if (retIsBusinessReality === false) {
                                    updateOutcomePercentage(optimized.innerId, optimized.currentOutcomePercentage);
                                  }
                                  updateIsBusinessReality(optimized.innerId, !retIsBusinessReality);
                                }}
                                disabled={!canEditAssumptions}
                              />
                              <span className={retIsBusinessReality ? styles.yPosHammer : styles.nPosHammer}>
                                {retIsBusinessReality ? "Yes" : "No"}
                              </span>
                            </div>
                          </span>
                        </div>
                      )}
                      <div className={styles.shareHeader}>
                        <div className={styles.countEditOne} style={{ paddingLeft: "0px" }}>
                          {"Measure"}
                        </div>
                        <div
                          className={styles.countEditTwo}
                          style={{
                            textAlign: isOverallSegment ? "right" : "left"
                          }}
                        >
                          {"Initial State"}
                        </div>
                        <div
                          className={styles.countEditThree}
                          style={{
                            paddingRight: "0px",
                            textAlign: isOverallSegment ? "right" : "left"
                          }}
                        >
                          {"Expected" + (!retIsBusinessReality ? " (New)" : "")}
                        </div>
                      </div>
                      {isOverallSegment ? (
                        <div>
                          <div className={styles.countItem}>
                            <div className={styles.countEditOne}>{"Count"}</div>
                            <div className={styles.countEditTwo}>
                              {optimized ? numeral(optimized.overallContinuousCount).format("0a") : 0}
                            </div>
                            <div className={styles.countEditThree}>
                              {optimized ? numeral(optimized.overallExpectedContinuousCount).format("0a") : 0}
                            </div>
                          </div>
                          <div className={styles.countItem}>
                            <div className={styles.countEditOne}>{"Average"}</div>
                            <div className={styles.countEditTwo}>
                              {optimized ? numeral(optimized.overallContinuousValue).format("0.0a") : 0}
                            </div>
                            <div className={styles.countEditThree}>
                              {" "}
                              {optimized ? numeral(optimized.overallExpectedContinuousValue).format("0.0a") : 0}
                            </div>
                          </div>
                        </div>
                      ) : retIsBusinessReality === true ? (
                        <div>
                          <div className={styles.countItem}>
                            <div className={styles.countEditOne}>{"Count"}</div>
                            <div className={styles.countEditTwo}>
                              {optimized ? numeral(optimized.continuousCount).format("0a") : 0}
                            </div>
                            <div className={styles.countEditThree}>
                              {optimized && optimized.setup && !isNaN(optimized.setup.expectedCountContinuous)
                                ? numeral(optimized.setup.expectedCountContinuous).format("0a")
                                : optimized.continuousCount
                                  ? numeral(optimized.continuousCount).format("0a")
                                  : 0}
                            </div>
                          </div>
                          <div className={styles.countItem}>
                            <div className={styles.countEditOne}>{"Average"}</div>
                            <div className={styles.countEditTwo}>
                              {optimized ? numeral(optimized.continuousValue).format("0.0a") : 0}
                            </div>
                            <div className={styles.countEditThree}>
                              {" "}
                              {optimized && optimized.setup && !isNaN(optimized.setup.expectedValueContinuous)
                                ? numeral(optimized.setup.expectedValueContinuous).format("0.0a")
                                : optimized.continuousValue
                                  ? numeral(optimized.continuousValue).format("0.0a")
                                  : 0}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className={styles.countEditItem}>
                            <div className={styles.countEditOne}>{"Count"}</div>
                            <div className={styles.countEditTwoContinuous} style={{ textAlign: "left" }}>
                              {optimized ? numeral(optimized.continuousCount).format("0a") : 0}
                            </div>
                            <div className={styles.countEditThreeContinuous}>
                              <LineInput
                                key={optimized && optimized.innerSegment ? optimized.innerSegment.id : "none"}
                                isMediumBox
                                defaultValue={
                                  optimized && optimized.setup && optimized.setup.expectedCountContinuous
                                    ? undefined
                                    : optimized.continuousCount
                                }
                                value={
                                  optimized && optimized.setup && optimized.setup.expectedCountContinuous
                                    ? optimized.setup.expectedCountContinuous
                                    : undefined
                                }
                                onChange={
                                  optimized &&
                                  optimized.innerSegment &&
                                  optimized.innerSegment.job &&
                                  optimized.innerSegment.job.job_id
                                    ? (val) => updateExpectedCountContinuous(optimized.innerSegment.job.job_id, val)
                                    : () => {}
                                }
                                isLocked={!canEditAssumptions}
                              />
                            </div>
                          </div>
                          <div className={styles.countEditItem}>
                            <div className={styles.countEditOne}>{"Average"}</div>
                            <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                              {optimized ? numeral(optimized.continuousValue).format("0.0a") : 0}
                            </div>
                            <div className={styles.countEditThree}>
                              <LineInput
                                key={optimized && optimized.innerSegment ? optimized.innerSegment.id : "none"}
                                isMediumBox
                                defaultValue={
                                  optimized && optimized.setup && optimized.setup.expectedValueContinuous
                                    ? undefined
                                    : optimized.continuousValue
                                }
                                value={
                                  optimized && optimized.setup && optimized.setup.expectedValueContinuous
                                    ? optimized.setup.expectedValueContinuous
                                    : undefined
                                }
                                onChange={
                                  optimized &&
                                  optimized.innerSegment &&
                                  optimized.innerSegment.job &&
                                  optimized.innerSegment.job.job_id
                                    ? (val) => updateExpectedValueContinuous(optimized.innerSegment.job.job_id, val)
                                    : () => {}
                                }
                                isLocked={!canEditAssumptions}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={styles.nItemBotHelp + " " + styles.collabWindow}>
                      <div className={styles.nHeaderHelp + " " + styles.collab}>
                        {"Collaboration"}
                        <div className={styles.hSelect}>
                          {canManageSegmentPermissions ? (
                            <Button
                              active={isSharing}
                              style={{ padding: "5px" }}
                              onClick={() => {
                                updateProjectSetting("isSharing", !isSharing);
                                updateProjectSetting("isAFO", false);
                                this.setState({
                                  isAssumptions: false
                                });
                              }}
                            >
                              {"Edit Collaborators"}
                            </Button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className={styles.nHelp}>
                        {isOverallSegment ? (
                          <div className={styles.shareHeader}>
                            <div className={styles.sHeaderOne}>{"Subgroup"}</div>
                            <div className={styles.sheaderTwo}>{"Collaborators"}</div>
                          </div>
                        ) : (
                          <div className={styles.shareHeader}>
                            <div className={styles.sHeaderOne}>{"Name"}</div>
                            <div className={styles.sheaderTwo}>{"Pending Edits"}</div>
                          </div>
                        )}
                        {isOverallSegment
                          ? project.segments
                              .filter((s, i) => i > 0)
                              .sort((a, b) =>
                                a.conditions &&
                                b.conditions &&
                                a.conditions.length > 0 &&
                                b.conditions.length > 0 &&
                                b.conditions[0].value < a.conditions[0].value
                                  ? 1
                                  : -1
                              )
                              .map((s) => this.renderSharingSegment(s))
                          : this.renderSharingSegment(optimized.innerSegment)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.overallBody}></div>
        </div>
      </div>
    );
  }

  renderRecalibrateOutcomePercentage(businessRealityOverride = undefined) {
    const {
      optimizer,
      optimized,
      modelGroups,
      project,
      deployment,
      scaledTotal,
      updateScaledTotal,
      updateOutcomePercentage,
      isBusinessReality,
      updateIsBusinessReality
    } = this.props;
    const { recalibrate } = this.state;
    if (!optimized) {
      return <div />;
    }

    const retIsBusinessReality = businessRealityOverride !== undefined ? businessRealityOverride : isBusinessReality;

    const outcome = optimized.dataset && optimized.dataset.outcome;
    const toPredict = optimized.setup && optimized.setup.success && optimized.setup.success.label;

    const isOverallSegment = this.getIsOverallSegment();

    const segmentLabel =
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions &&
      optimized.innerSegment.conditions.length > 0
        ? optimized.innerSegment.conditions[0].value
        : "Overall";

    return (
      <div className={styles.oItemBotContent} style={{ overflowX: "hidden", marginTop: "6px" }}>
        {isOverallSegment ? (
          modelGroups.drilldownValues
            .filter((d) => d.value !== "Overall")
            .map((d, i) => (
              <div className={styles.fSlider} key={i}>
                <div className={styles.tMsg}>{d.value}</div>
                {d.currentOutcomePercentage === d.outcomePercentage && recalibrate[d.value] !== true ? (
                  <a
                    onClick={() =>
                      this.setState({
                        recalibrate: { ...recalibrate, [d.value]: true }
                      })
                    }
                  >
                    {"Click to recalibrate"}
                  </a>
                ) : (
                  <div>
                    <div className={styles.tSlider}>
                      <div>{"Initial State"}</div>
                      <div style={{ paddingLeft: "20px" }}>
                        <Slider
                          value={(d.originalOutcomePercentage * 100).toPrecision(3)}
                          min={0}
                          max={100}
                          step={0.1}
                          endLabel={"% " + toPredict}
                          isLocked
                          inputWidth={50}
                          isProject
                          color={"#868595"}
                        />
                      </div>
                    </div>
                    {deployment && !retIsBusinessReality ? (
                      <div className={styles.tSlider}>
                        <div>{"Deployed"}</div>
                        <div style={{ paddingLeft: "20px" }}>
                          <Slider
                            value={(d.currentOutcomePercentage * 100).toPrecision(3)}
                            min={0}
                            max={100}
                            step={0.1}
                            endLabel={"% " + toPredict}
                            isLocked
                            inputWidth={50}
                            isProject
                            color={"#868595"}
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <React.Fragment>
                      <div className={styles.tSlider} style={{ marginTop: "10px" }}>
                        <div>{"Expected Future Percentage"}</div>
                        <div style={{ paddingLeft: "20px" }}>
                          <Slider
                            value={(d.outcomePercentage * 100).toPrecision(3)}
                            onAfterChange={() => this.props.resetBudget()}
                            onChange={(val) => updateOutcomePercentage(d.runId, val / 100)}
                            min={0}
                            max={100}
                            step={0.1}
                            endLabel={"% " + toPredict}
                            inputWidth={50}
                            isProject
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  </div>
                )}
              </div>
            ))
        ) : (
          <div className={styles.countItem}>
            <div className={styles.countEditOne}>{segmentLabel}</div>
            <div className={styles.countEditTwo}>
              {Number(optimized.originalOutcomePercentage * 100).toFixed(2) + "%"}
            </div>
            {deployment && !retIsBusinessReality ? (
              <div className={styles.countEditTwo}>
                {Number(optimized.currentOutcomePercentage * 100).toFixed(2) + "%"}
              </div>
            ) : (
              ""
            )}
            <div className={styles.countEditThree}>{Number(optimized.outcomePercentage * 100).toFixed(2) + "%"}</div>
          </div>
        )}
        {isOverallSegment ? <div /> : <div />}
        {isOverallSegment === false && retIsBusinessReality === false ? (
          <React.Fragment>
            <div
              className={styles.tSlider}
              style={{
                marginBottom: "10px",
                marginTop: "20px",
                marginLeft: "5px"
              }}
            >
              <div>{"Expected Future Percentage"}</div>
              <Slider
                value={(optimized.outcomePercentage * 100).toPrecision(3)}
                onAfterChange={() => this.props.resetBudget()}
                onChange={(val) => updateOutcomePercentage(optimized.innerId, val / 100)}
                min={0}
                max={100}
                step={0.1}
                endLabel={"% " + toPredict}
                inputWidth={50}
                isProject
              />
            </div>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    );
  }

  getLabelFromSegment(segment) {
    return segment.conditions.length === 0 ? "Overall" : segment.conditions[0].value;
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderSharingSegment(segment) {
    const { allScenarios, project, optimized, updateDrilldownValue, updateShowShortListed } = this.props;
    const { isAssumptions } = this.state;

    const isOverallSegment = this.getIsOverallSegment();

    const roles = segment.roles.filter((r) => segment.conditions.length == 0 || r.role_type != "VIEWER");

    return (
      <div key={segment.id}>
        {isOverallSegment ? (
          <div className={styles.sharingTableRow}>
            {this.getLabelFromSegment(segment)}
            <div className={styles.sharingTableCell}>{roles.length}</div>
          </div>
        ) : (
          roles.map((r, i) => {
            const editCount = allScenarios.filter((s) => {
              return (
                segment &&
                segment.conditions &&
                segment.conditions.length > 0 &&
                s.originalScenario &&
                s.originalScenario.created_by &&
                s.originalScenario.created_by.id === r.role_user.id &&
                s.originalScenario.status === "DRAFT" &&
                s.originalScenario.elements &&
                s.originalScenario.elements.filter(
                  (e) => e.assumption_id === s.scenario[segment.conditions[0].value].setup.id
                ).length > 0
              );
            }).length;

            return editCount === 0 ? (
              <div className={styles.sharingTableRow} key={i}>
                {r.role_user.fullname}
                <div className={styles.sharingTableCell}>{editCount}</div>
              </div>
            ) : (
              <a
                key={i}
                className={styles.sharingTableRow}
                onClick={() => {
                  updateShowShortListed(false);
                  return this.setState({
                    userFilter: r.role_user.id
                  });
                }}
              >
                {r.role_user.fullname}
                <div className={styles.sharingTableCell}>{editCount}</div>
              </a>
            );
          })
        )}
      </div>
    );
  }

  parseValueName(name) {
    if (name.includes("more than ") && name.includes(" to ")) {
      return name.replace("more than", ">");
    }
    return name;
  }

  renderDrivers(topDrivers, count = 10, showValues = false) {
    const { updateModelFeedback, username } = this.props;

    const feedbackCount =
      topDrivers && topDrivers.bestModel && topDrivers.segment && topDrivers.segment.roles
        ? topDrivers.segment.roles.reduce(
            (a, b) =>
              a +
              (b &&
              b.preferences &&
              b.preferences.feedback &&
              b.preferences.feedback[topDrivers.bestModel.id] !== undefined
                ? Number(b.preferences.feedback[topDrivers.bestModel.id])
                : 0),
            0
          )
        : 0;

    return topDrivers === undefined ? (
      <div />
    ) : (
      <div style={{ marginBottom: "20px" }} key={topDrivers.drilldownValue}>
        <div className={styles.dHeader} style={{ fontWeight: "bold" }}>
          {topDrivers.drilldownValue}
          <div className={styles.dFeedback}>
            <ButtonGroup>
              <Button
                onClick={
                  topDrivers.bestModel && topDrivers.bestModel.id !== undefined
                    ? () => updateModelFeedback(topDrivers.runId, topDrivers.bestModel.id, true)
                    : () => {}
                }
                style={{ padding: "5px" }}
              >
                <FontAwesomeIcon icon={faThumbsUp} />
              </Button>
              <Button
                onClick={
                  topDrivers.bestModel && topDrivers.bestModel.id !== undefined
                    ? () => updateModelFeedback(topDrivers.runId, topDrivers.bestModel.id, false)
                    : () => {}
                }
                style={{ padding: "5px" }}
              >
                <FontAwesomeIcon icon={faThumbsDown} />
              </Button>
            </ButtonGroup>
            <div
              className={styles.dNumber}
              style={{
                color:
                  feedbackCount < 0
                    ? "rgb(248, 205, 126)"
                    : feedbackCount > 0
                      ? "rgb(91, 207, 116)"
                      : "rgb(230, 230, 252)"
              }}
            >
              {(feedbackCount > 0 ? "+" : "") + feedbackCount}
            </div>
          </div>
        </div>
        {topDrivers && topDrivers.columnDrivers === undefined ? (
          <LoadingIndicator style={{ margin: "0px", marginBottom: "20px" }} />
        ) : (
          <div />
        )}
        {topDrivers &&
          topDrivers.columnDrivers &&
          topDrivers.columnDrivers
            .filter((m, i) => i < count)
            .map((m, i) => (
              <div className={styles.driverWrapper + " " + (showValues ? styles.hasValues : "")} key={i + m.field}>
                <div className={styles.driverTitle + " " + (showValues ? "" : styles.hideValues)}>{m.field}</div>
                {showValues ? (
                  <React.Fragment>
                    {m.maxName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.increase}>
                          <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faArrowAltCircleUp} />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.maxName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {m.minName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.decrease}>
                          <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faArrowAltCircleDown} />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.minName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            ))}
      </div>
    );
  }

  renderOverall() {
    const {
      optimized,
      optimizer,
      project,
      deployment,
      createSplits,
      modelGroups,
      groupInfo,
      isAFO,
      isSharing,
      isBusinessReality,
      setMinBudget,
      setMaxBudget,
      scaledTotal,
      setSalesBudget,
      selectedScenario,
      updateInnerId,
      updateOutcomePercentage,
      updateProjectSetting,
      updateDrilldownValue,
      updateIsBusinessReality,
      updateTruePositive,
      updateTrueNegative,
      updateFalsePositive,
      updateFalseNegative,
      updateConversionGain,
      updateConversionCost,
      updateConversionMissed,
      updateConversionSaved,
      updateCustomValue,
      updateScaledTotal,
      segmentOptions,
      canManageSegmentPermissions
    } = this.props;

    const {
      isExplain,
      isEditMarketing,
      isEditSales,
      isEditMarketingImpacts,
      isEditSalesImpacts,
      isHideCustomValues,
      isAssumptions,
      isCreating,
      isShowCurrentState,
      scenarioName,
      recalibrate
    } = this.state;

    const canEditAssumptions =
      optimizer.drilldownValue === "Overall" ||
      (segmentOptions &&
        segmentOptions.some((s) => s.value === optimizer.drilldownValue && s.runId === optimized.innerId));
    const retIsBusinessReality =
      !canEditAssumptions ||
      (optimized.isBusinessReality !== false && optimized.currentOutcomePercentage === optimized.outcomePercentage);

    const topDrivers =
      modelGroups &&
      modelGroups.topDrivers &&
      modelGroups.topDrivers &&
      modelGroups.topDrivers.filter((m) => m.drilldownValue === optimizer.drilldownValue).length > 0
        ? modelGroups.topDrivers.filter((m) => m.drilldownValue === optimizer.drilldownValue)[0]
        : undefined;

    let mTotal = 0;
    if (groupInfo.marketing[optimizer.drilldownValue]) {
      Object.keys(groupInfo.marketing[optimizer.drilldownValue]).forEach((v) => {
        mTotal += groupInfo.marketing[optimizer.drilldownValue][v].cost;
      });
    }

    const hasCustomValues =
      optimized &&
      optimized.setup &&
      optimized.setup.customValues &&
      Object.keys(optimized.setup.customValues).length > 0;

    const showCustomValues = isHideCustomValues !== true && hasCustomValues;

    const splitOptions =
      optimized && optimized.dataset
        ? Object.keys(optimized.dataset.fields)
            .filter((f) => optimized.dataset.fields[f].type === "categorical" && f !== optimized.dataset.outcome)
            .filter((f) =>
              optimized && optimized.setup && optimized.setup.ignored && optimized.setup.ignored[f] ? false : true
            )
            .map((f) => ({
              label: optimized.dataset.fields[f].label,

              value: optimized.dataset.fields[f].label
            }))
        : [];

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];

    let drilldownSlice = undefined;

    for (let value of drilldownValues) {
      if (
        value.value != "Overall" &&
        (optimizer.drilldownValue == "Overall" || value.value === optimizer.drilldownValue)
      ) {
        drilldownSlice = value;
        break;
      }
    }

    const otherSlices = drilldownSlice
      ? drilldownValues.filter((v) => v && v.column && v.column == drilldownSlice.column && v.column !== "Overall")
      : undefined;

    let loadingSplits = false;

    otherSlices &&
      otherSlices.forEach((v) => {
        if (isNaN(v.optimalPct)) {
          loadingSplits = true;
        }
      });

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const maxBudgetSetup =
      optimized && optimized.setup
        ? (Number(optimized.setup.truePositive) +
            Number(optimized.setup.falsePositive) +
            Number(optimized.setup.trueNegative) +
            Number(optimized.setup.falseNegative)) *
          (optimized.setup.advancedCost !== undefined
            ? Math.abs(optimized.setup.advancedCost)
            : Math.abs(optimized.setup.advancedCost))
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    const shouldRerun =
      optimized &&
      optimized.activeSegment &&
      optimized.activeSegment.assumption &&
      isSameSetup(optimized.activeSegment.assumption.data, optimized.setup.jobSetup) === false;

    const outcome = optimized.dataset && optimized.dataset.outcome;
    const toPredict = optimized.setup && optimized.setup.success && optimized.setup.success.label;

    const isEditCounts = !retIsBusinessReality;

    return (
      <div className={styles.overall}>
        <div
          className={styles.currentToggle}
          style={{
            width: isAFO || isExplain || isSharing ? "calc(100% - 500px)" : "100%"
          }}
        >
          {optimized.hasSameScenario && selectedScenario ? (
            <div className={styles.cToggle}>
              <div>
                {selectedScenario.originalScenario.created_by.fullname + ": " + selectedScenario.originalScenario.name}
              </div>
              {}
              <div className={styles.cHolder}>
                {/*
                <span style={{ marginRight: "5px" }}>{"Current State"}</span>
                <Toggle
                  defaultChecked={isShowCurrentState}
                  icons={false}
                  onChange={(e) =>
                    this.setState({
                      isShowCurrentState: e.target.checked,
                    })
                  }
                />
                <span
                  className={isShowCurrentState ? styles.yPos : styles.nPos}
                  style={{ fontSize: "12px", fontWeight: "initial" }}
                >
                  {!isShowCurrentState ? "Off" : "On"}
                </span>
              */}
              </div>
            </div>
          ) : (
            <div className={styles.cToggle}>
              <div>{"New Scenario: " + scenarioName}</div>
              <div className={styles.cHolder}>
                {/*
                <span style={{ marginRight: "5px" }}>{"Current State"}</span>
                <Toggle
                  defaultChecked={isShowCurrentState}
                  icons={false}
                  onChange={(e) =>
                    this.setState({
                      isShowCurrentState: e.target.checked,
                    })
                  }
                />
                <span
                  className={isShowCurrentState ? styles.yPos : styles.nPos}
                  style={{ fontSize: "12px", fontWeight: "initial" }}
                >
                  {!isShowCurrentState ? "Off" : "On"}
                </span>
              */}
              </div>
            </div>
          )}
        </div>
        <div
          className={styles.overallSection}
          style={{
            width: isAFO || isExplain || isSharing ? "calc(100% - 500px)" : "100%"
          }}
        >
          <div className={styles.overallSectionBackground} />
          <div className={styles.mItem}>
            <div>
              <div
                className={styles.midHeaderHolder}
                style={isShowCurrentState ? { paddingBottom: "10px" } : { maxHeight: "0px" }}
              >
                <div className={styles.bHeader}>{"Current " + optimized.resourcingLabel}</div>
                <div>
                  {optimized.isCurrencyUnitType ? (
                    <div className={styles.sHero}>
                      {optimized.unitLabel}
                      {numeral(optimized.currentSpend).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.sHero} style={{ display: "block" }}>
                      {numeral(optimized.currentSpend).format("0.0a")}
                      <div className={styles.subLabel}>{optimized.unitLabel}</div>
                    </div>
                  )}
                  <div
                    className={
                      styles.oItemHeader +
                      " " +
                      (optimized.currentSpend > optimized.totalCost
                        ? styles.oItemHeaderNegative
                        : styles.oItemHeaderPositive)
                    }
                  >
                    <div className={styles.leftRadius} />
                    <div className={styles.oIContent}>
                      <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: "5px" }} />
                      {(optimized.currentSpend > optimized.totalCost ? "Overspending by " : "Underspending by ") +
                        (Math.abs(
                          Math.round((optimized.totalCost - optimized.currentSpend) / (optimized.currentSpend || 1))
                        ) > 2
                          ? Math.abs(
                              Math.round((optimized.totalCost - optimized.currentSpend) / (optimized.currentSpend || 1))
                            ) + "x"
                          : Math.round(
                              Math.abs((optimized.totalCost - optimized.currentSpend) / (optimized.currentSpend || 1)) *
                                100
                            ) + "%")}
                    </div>
                    <div className={styles.rightRadius} />
                  </div>
                </div>
              </div>
              <div className={styles.mItemMid + " " + styles.dropShadow}>
                {isEditMarketing === true ? (
                  <div className={styles.bHeaderHolder}>
                    <div className={styles.newItemHeader}>{"Edit Resource Constraints"}</div>
                    <div className={styles.newOItemContent}>
                      <div className={styles.tInput} style={{ marginTop: "20px" }}>
                        <LineInput
                          topLabel={"Maximum"}
                          isMediumBox
                          onChange={(val) =>
                            setMaxBudget(optimized.id, isNaN(val) || val === "" ? undefined : Number(val))
                          }
                          value={maxBudget || maxBudget === 0 ? maxBudget : "No Constraint"}
                          forceCommas
                        />
                      </div>
                      <div className={styles.tInput}>
                        <LineInput
                          topLabel={"Aible Optimal (Constrained)"}
                          isMediumBox
                          isDisabled
                          value={optimized.totalCost}
                          forceCommas
                        />
                      </div>
                      <div className={styles.tInput}>
                        <LineInput
                          topLabel={"Minimum"}
                          isMediumBox
                          onChange={(val) =>
                            setMinBudget(optimized.id, isNaN(val) || val === "" ? undefined : Number(val))
                          }
                          value={minBudget || minBudget === 0 ? minBudget : "No Constraint"}
                          forceCommas
                        />
                      </div>
                      <div className={styles.closeHolder}>
                        <Button
                          onClick={() => this.setState({ isEditMarketing: false })}
                          style={{ marginBottom: "10px" }}
                        >
                          {"Close Editor"}
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className={styles.newItemHeader + " " + styles.subBackground}>
                      {"Optimal " + optimized.resourcingLabel}
                      <FontAwesomeIcon
                        className={styles.editIcon}
                        icon={faEdit}
                        onClick={() => this.setState({ isEditMarketing: true })}
                      />
                    </div>
                    {optimized.isCreatingSplit ? (
                      <div className={styles.newOItemContent}>
                        <LoadingIndicator style={{ marginTop: "-20px" }} />
                        <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                      </div>
                    ) : (
                      <div className={styles.newOItemContent}>
                        <div className={styles.cHero}>
                          {optimized.isCurrencyUnitType ? (
                            <div className={styles.sHero}>
                              {optimized.unitLabel}
                              {numeral(optimized.totalCost).format("0.0a")}
                            </div>
                          ) : (
                            <div className={styles.sHero} style={{ display: "block" }}>
                              {numeral(optimized.totalCost).format("0.0a")}
                              <div className={styles.subLabel}>{optimized.unitLabel}</div>
                            </div>
                          )}
                        </div>
                        <TinyBarChart
                          bars={[
                            {
                              label: "Optimal " + optimized.resourcingLabel,
                              Cost: optimized.totalCost
                            },
                            {
                              label: "Current " + optimized.resourcingLabel,
                              Cost: optimized.currentSpend
                            }
                          ]}
                          unit={optimized.unitLabel}
                          isCurrencyUnit={optimized.isCurrencyUnitType}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.mItem}>
            <div
              className={styles.midHeaderHolder}
              style={isShowCurrentState ? { paddingBottom: "10px" } : { maxHeight: "0px" }}
            >
              <div className={styles.bHeader} style={{ justifyContent: "center" }}>
                {"Current Mix"}
              </div>
              {project && project.segments && project.segments.length === 1 ? (
                <div className={styles.smallPieHolder}>{"Select field to split"}</div>
              ) : (
                <div className={styles.smallPieHolder}>
                  <PieChart
                    isSmall
                    secondaryColors
                    pData={
                      otherSlices
                        ? otherSlices.map((s) => ({
                            name: s.value,
                            runId: s.runId,
                            value: Math.round(s.currentCost),
                            color: s.value === optimizer.drilldownValue ? "#F47C20" : undefined
                          }))
                        : []
                    }
                    onClick={(runId, name) => updateDrilldownValue(runId, name)}
                    unit={optimized.unitLabelShort}
                  />
                </div>
              )}
            </div>
            <div className={styles.mItemMid + " " + styles.dropShadow}>
              <div className={styles.newItemHeader + " " + styles.subBackground}>{"Optimal Mix"}</div>
              <div className={styles.newOItemContent} style={{ overflow: "visible" }}>
                {project && project.segments && project.segments.length === 1 && isCreating !== true ? (
                  <div className={styles.splitFieldHolder}>
                    <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
                      {"Split on Field"}
                    </div>
                    <div className={styles.splitField}>
                      <Select options={splitOptions} ref="splitOne" />
                    </div>
                    <Button
                      onClick={() => {
                        this.setState({ isCreating: true });
                        setTimeout(() => this.setState({ isCreating: false }), 5000);
                        createSplits(
                          this.refs["splitOne"].state.value !== null
                            ? this.refs["splitOne"].state.value.value
                            : undefined
                        );
                      }}
                    >
                      {"Create Subgroups"}
                    </Button>
                  </div>
                ) : loadingSplits || isCreating ? (
                  <div className={styles.smallLoader} style={{ padding: "2vw" }}>
                    <LoadingIndicator style={{ marginTop: "-20px" }} />
                    <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                  </div>
                ) : (
                  <div>
                    <div className={styles.pieHolder}>
                      <PieChart
                        secondaryColors
                        pData={
                          otherSlices
                            ? otherSlices.map((s) => ({
                                name: s.value,
                                runId: s.runId,
                                value: Math.round(s.optimalPct),
                                color: s.value === optimizer.drilldownValue ? "#F47C20" : s.color
                              }))
                            : []
                        }
                        onClick={(runId, name) => updateDrilldownValue(runId, name)}
                        unit={optimized.unitLabelShort}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.mItem}>
            <div
              className={styles.midHeaderHolder}
              style={isShowCurrentState ? { paddingBottom: "10px" } : { maxHeight: "0px" }}
            >
              <div className={styles.bHeader} style={{ justifyContent: "center" }}>
                {"Current " + optimized.revenueLabel}
              </div>
              {optimized.isCurrencyUnitType ? (
                <div className={styles.sHero}>
                  {optimized.unitLabel}
                  {numeral(optimized.currentRevenue).format("0.0a")}
                </div>
              ) : (
                <div className={styles.sHero} style={{ display: "block" }}>
                  {numeral(optimized.currentRevenue).format("0.0a")}
                  <div className={styles.subLabel}>{optimized.unitLabel}</div>
                </div>
              )}
              <div style={{ height: "20px" }} />
            </div>
            <div className={styles.mItemMid + " " + styles.dropShadow}>
              <div className={styles.newItemHeader + " " + styles.subBackground}>
                {"Expected " + optimized.revenueLabel}
              </div>
              {optimized.isCreatingSplit ? (
                <div className={styles.newOItemContent}>
                  <LoadingIndicator style={{ marginTop: "-20px" }} />
                  <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Generating frontiers"}</div>
                </div>
              ) : (
                <div className={styles.newOItemContent}>
                  <div className={styles.cHero}>
                    {optimized.isCurrencyUnitType ? (
                      <div className={styles.sHero}>
                        {optimized.unitLabel}
                        {numeral(optimized.revenue).format("0.0a")}
                      </div>
                    ) : (
                      <div className={styles.sHero} style={{ display: "block" }}>
                        {numeral(optimized.revenue).format("0.0a")}
                        <div className={styles.subLabel}>{optimized.unitLabel}</div>
                      </div>
                    )}
                  </div>
                  <TinyBarChart
                    bars={[
                      {
                        label: "Expected " + optimized.revenueLabel,
                        Cost: optimized.revenue
                      },
                      {
                        label: "Current " + optimized.revenueLabel,
                        Cost: optimized.revenue - optimized.revenueDelta
                      }
                    ]}
                    unit={optimized.unitLabel}
                    isCurrencyUnit={optimized.isCurrencyUnitType}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={styles.mItem}>
            <div className={styles.bHeaderHolder}>
              <div
                className={styles.midHeaderHolder}
                style={isShowCurrentState ? { paddingBottom: "10px" } : { maxHeight: "0px" }}
              >
                <div className={styles.bHeader} style={{ justifyContent: "center" }}>
                  {"Current " + optimized.profitLabel}
                </div>
                {optimized.isCurrencyUnitType ? (
                  <div className={styles.sHero}>
                    {optimized.unitLabel}
                    {numeral(optimized.currentProfit).format("0.0a")}
                  </div>
                ) : (
                  <div className={styles.sHero} style={{ display: "block" }}>
                    {numeral(optimized.currentProfit).format("0.0a")}
                    <div className={styles.subLabel}>{optimized.unitLabel}</div>
                  </div>
                )}
                {isNaN(Math.abs(optimized.currentRevenue - optimized.currentSpend - optimized.currentProfit)) ? (
                  <div>&nbsp;</div>
                ) : (
                  <div>
                    {"After " + optimized.unitLabelShort}
                    <span>
                      {numeral(
                        Math.abs(optimized.currentRevenue - optimized.currentSpend - optimized.currentProfit)
                      ).format("0.0a")}
                    </span>
                    {" in other costs"}
                  </div>
                )}
              </div>
            </div>
            {this.renderProfitBox()}
          </div>
        </div>
        <div className={styles.midHolder} style={isShowCurrentState ? { marginTop: "340px" } : { marginTop: "240px" }}>
          <div className={styles.midBody}>
            <FrontierSlidersContainer id={project && project.id} />
          </div>
          <div className={styles.newBottomContent}>
            <div className={styles.bottomPanel}>
              <div className={styles.nItemBotHolder}>
                <div className={styles.nItemBotItem}>
                  <div className={styles.nItemBotHeader}>
                    {"Key Drivers"}
                    <PredictionDriverToolTip />
                  </div>
                  <div className={styles.nItemBotContent} style={{ overflow: "auto" }}>
                    {isOverallSegment
                      ? modelGroups.topDrivers.filter((s, i) => i > 0).map((s) => this.renderDrivers(s, 4, false))
                      : this.renderDrivers(
                          (modelGroups.topDrivers || []).find((driver) => driver.runId === optimized.innerId),
                          5,
                          true
                        )}
                  </div>
                </div>
                <div className={styles.nRight}>
                  <div className={styles.legendHolder}>
                    <div className={styles.legendTitle}>{"Assumptions"}</div>
                    <AssumptionLegend
                      data={modelGroups.drilldownValues}
                      innerId={optimized.innerId}
                      updateDrilldownValue={(runId, name) => {
                        if (name === "Overall") {
                          this.setState({
                            isEditMarketingImpacts: false
                          });
                        }
                        return updateInnerId(runId);
                      }}
                    />
                  </div>
                  <div className={styles.nItemRightHolder}>
                    {isOverallSegment === false ? (
                      <div className={styles.nItemBotHelp}>
                        <div className={styles.nHeaderHelp}>
                          {"Business Drivers"}

                          {/*
                          <Button
                            style={{ marginLeft: "5px", fontWeight: "normal" }}
                            isSmall
                            onClick={() =>
                              this.setState({ isEditMarketingImpacts: false })
                            }
                          >
                            {"OK"}
                          </Button>
                          */}
                          {isEnabled("aible-for-business-advanced-assumptions") && hasCustomValues && (
                            <div className={styles.customValueToggle}>
                              <Button
                                style={{ fontWeight: "normal" }}
                                active={isHideCustomValues === true}
                                onClick={() =>
                                  this.setState({
                                    isHideCustomValues: !isHideCustomValues
                                  })
                                }
                                isSmall
                              >
                                {"Advanced"}
                              </Button>
                            </div>
                          )}
                        </div>
                        {showCustomValues ? (
                          <div>
                            <div className={styles.shareHeader}>
                              <div className={styles.costEditThirdsOne} style={{ paddingLeft: "0px" }}>
                                {"Measure"}
                              </div>
                              <div className={styles.costEditThirdsTwo}>{"Current"}</div>
                              <div className={styles.costEditThirdsThree}>{"Expected (New)"}</div>
                            </div>
                            <div className={styles.aHolder}>
                              {Object.keys(optimized.setup.customValues).map((v, i) => {
                                const showWarning = checkValueWarning(
                                  optimized.setup.customValues[v],
                                  optimized.originalSetup.customValues[v]
                                );
                                return (
                                  <div key={v + i} className={styles.assumptionEditItem}>
                                    <div className={styles.costEditThirdsOne} title={v}>
                                      {v}
                                    </div>
                                    <div
                                      className={styles.costEditThirdsTwo}
                                      title={optimized.originalSetup.customValues[v]}
                                    >
                                      {optimized.originalSetup.customValues[v]}
                                    </div>
                                    <div className={styles.costEditThirdsThree}>
                                      <LineInput
                                        isMediumBox
                                        value={optimized.setup.customValues[v]}
                                        onChange={(val) =>
                                          updateCustomValue(optimized.innerId, optimized.setup.blueprintId, v, val)
                                        }
                                        isLocked={!canEditAssumptions}
                                        isWarning={showWarning}
                                        warning={
                                          showWarning &&
                                          getWarningMessage(
                                            optimized.setup.customValues[v],
                                            optimized.originalSetup.customValues[v]
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className={styles.shareHeader}>
                              <div className={styles.costEditOne} style={{ paddingLeft: "0px" }}>
                                {"Measure"}
                              </div>
                              <div className={styles.costEditOne}>{"Expected"}</div>
                            </div>
                            <div className={styles.assumptionEditItem}>
                              <div className={styles.costEditOne}>{optimized.setup.truePositiveLabel}</div>
                              <div className={styles.costEditOne}>
                                <LineInput
                                  isMediumBox
                                  value={optimized.setup.conversionGain}
                                  onChange={(val) => updateConversionGain(optimized.innerId, val)}
                                  isLocked={!canEditAssumptions}
                                />
                              </div>
                            </div>
                            <div className={styles.assumptionEditItem}>
                              <div className={styles.costEditOne}>{optimized.setup.falsePositiveLabel}</div>
                              <div className={styles.costEditTwo}>
                                <LineInput
                                  isMediumBox
                                  value={optimized.setup.conversionCost}
                                  onChange={(val) => updateConversionCost(optimized.innerId, val)}
                                  isLocked={!canEditAssumptions}
                                />
                              </div>
                            </div>
                            <div className={styles.assumptionEditItem}>
                              <div className={styles.costEditOne}>{optimized.setup.trueNegativeLabel}</div>
                              <div className={styles.costEditTwo}>
                                <LineInput
                                  isMediumBox
                                  value={optimized.setup.conversionSaved}
                                  onChange={(val) => updateConversionSaved(optimized.innerId, val)}
                                  isLocked={!canEditAssumptions}
                                />
                              </div>
                            </div>
                            <div className={styles.assumptionEditItem}>
                              <div className={styles.costEditOne}>{optimized.setup.falseNegativeLabel}</div>
                              <div className={styles.costEditTwo}>
                                <LineInput
                                  isMediumBox
                                  value={optimized.setup.conversionMissed}
                                  onChange={(val) => updateConversionMissed(optimized.innerId, val)}
                                  isLocked={!canEditAssumptions}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className={styles.nItemBotHelp}>
                        <div className={styles.nHeaderHelp} style={{ paddingLeft: "5px" }}>
                          {"Business Drivers"}
                          {isOverallSegment ? (
                            <span />
                          ) : (
                            <FontAwesomeIcon
                              className={styles.editIcon}
                              icon={faEdit}
                              onClick={() => this.setState({ isEditMarketingImpacts: true })}
                            />
                          )}
                          {isEnabled("aible-for-business-advanced-assumptions") && hasCustomValues && (
                            <div className={styles.customValueToggle}>
                              <Button
                                style={{ fontWeight: "normal" }}
                                active={isHideCustomValues === true}
                                onClick={() =>
                                  this.setState({
                                    isHideCustomValues: !isHideCustomValues
                                  })
                                }
                                isSmall
                              >
                                {"Advanced"}
                              </Button>
                            </div>
                          )}
                        </div>
                        <div className={styles.shareHeader}>
                          <div className={styles.costSectionOne} style={{ paddingLeft: "0px" }}>
                            {"Measure"}
                          </div>
                          <div className={styles.costSectionTwo}>{"Distribution"}</div>
                          <div className={styles.costSectionThree} style={{ paddingRight: "0px" }}>
                            {"Average"}
                          </div>
                        </div>
                        {showCustomValues ? (
                          <div
                            className={styles.oItemBotContent}
                            style={{
                              marginTop: "0px"
                            }}
                          >
                            <div className={styles.aholder}>
                              {Object.keys(optimized.setup.customValues).map((c, i) => {
                                const bpDesc =
                                  optimized &&
                                  optimized.blueprint &&
                                  optimized.blueprint &&
                                  optimized.blueprint.wizard &&
                                  optimized.blueprint.wizard.customFields &&
                                  optimized.blueprint.wizard.customFields[c] &&
                                  optimized.blueprint.wizard.customFields[c].desc
                                    ? optimized.blueprint.wizard.customFields[c].desc
                                    : c;

                                return (
                                  <div key={i} className={styles.assumptionItem}>
                                    <div className={styles.costSectionOne} title={bpDesc}>
                                      {c}
                                    </div>
                                    <div className={styles.costSectionTwo}>
                                      <ImpactSlider
                                        impacts={modelGroups.drilldownValues.map((v) => ({
                                          value: v.setup.customValues[c],
                                          drilldownValue: v.value,
                                          runId: v.runId
                                        }))}
                                        currentImpact={optimized.setup.customValues[c]}
                                        drilldownValue={optimizer.drilldownValue}
                                        updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                                      />
                                    </div>
                                    <div className={styles.costSectionThree}>
                                      {optimized.setup.customValues[c] !== undefined
                                        ? Number(optimized.setup.customValues[c]).toFixed(2)
                                        : ""}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          <div>
                            {modelGroups && modelGroups.drilldownValues && (
                              <div
                                className={styles.oItemBotContent}
                                style={{
                                  marginTop: "0px"
                                }}
                              >
                                <div className={styles.assumptionItem}>
                                  <div className={styles.costSectionOne}>{optimized.setup.truePositiveLabel}</div>
                                  <div className={styles.costSectionTwo}>
                                    <ImpactSlider
                                      impacts={modelGroups.drilldownValues.map((v) => ({
                                        value: v.setup.conversionGain,
                                        drilldownValue: v.value,
                                        runId: v.runId
                                      }))}
                                      currentImpact={optimized.setup.conversionGain}
                                      drilldownValue={optimizer.drilldownValue}
                                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                                    />
                                  </div>
                                  <div className={styles.costSectionThree}>
                                    {optimized.setup.conversionGain !== undefined
                                      ? Number(optimized.setup.conversionGain).toFixed(2)
                                      : ""}
                                  </div>
                                </div>
                                <div className={styles.assumptionItem}>
                                  <div className={styles.costSectionOne}>{optimized.setup.falsePositiveLabel}</div>
                                  <div className={styles.costSectionTwo}>
                                    <ImpactSlider
                                      impacts={modelGroups.drilldownValues.map((v) => ({
                                        value: v.setup.conversionCost,
                                        drilldownValue: v.value,
                                        runId: v.runId
                                      }))}
                                      currentImpact={optimized.setup.conversionCost}
                                      drilldownValue={optimizer.drilldownValue}
                                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                                    />
                                  </div>
                                  <div className={styles.costSectionThree}>
                                    {optimized.setup.conversionCost !== undefined
                                      ? Number(optimized.setup.conversionCost).toFixed(2)
                                      : ""}
                                  </div>
                                </div>
                                <div className={styles.assumptionItem}>
                                  <div className={styles.costSectionOne}>{optimized.setup.trueNegativeLabel}</div>
                                  <div className={styles.costSectionTwo}>
                                    <ImpactSlider
                                      impacts={modelGroups.drilldownValues.map((v) => ({
                                        value: v.setup.conversionSaved,
                                        drilldownValue: v.value,
                                        runId: v.runId
                                      }))}
                                      currentImpact={optimized.setup.conversionSaved}
                                      drilldownValue={optimizer.drilldownValue}
                                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                                    />
                                  </div>
                                  <div className={styles.costSectionThree}>
                                    {optimized.setup.conversionSaved !== undefined
                                      ? Number(optimized.setup.conversionSaved).toFixed(2)
                                      : ""}
                                  </div>
                                </div>
                                <div className={styles.assumptionItem}>
                                  <div className={styles.costSectionOne}>{optimized.setup.falseNegativeLabel}</div>
                                  <div className={styles.costSectionTwo}>
                                    <ImpactSlider
                                      impacts={modelGroups.drilldownValues.map((v) => ({
                                        value: v.setup.conversionGain,
                                        drilldownValue: v.value,
                                        runId: v.runId
                                      }))}
                                      currentImpact={optimized.setup.conversionMissed}
                                      drilldownValue={optimizer.drilldownValue}
                                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                                    />
                                  </div>
                                  <div className={styles.costSectionThree}>
                                    {optimized.setup.conversionMissed !== undefined
                                      ? Number(optimized.setup.conversionMissed).toFixed(2)
                                      : ""}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                    <div className={styles.nItemBotHelp}>
                      {isOverallSegment ? (
                        <div className={styles.nHeaderHelp}>{outcome + ": " + toPredict}</div>
                      ) : (
                        <div className={styles.nHeaderHelp}>
                          {"Will future behavior match current state?"}
                          <span
                            style={{
                              marginLeft: "10px",
                              position: "relative",
                              flexShrink: "0"
                            }}
                          >
                            <div>
                              <Toggle
                                checked={retIsBusinessReality}
                                icons={false}
                                onChange={(e) => {
                                  if (retIsBusinessReality === false) {
                                    updateOutcomePercentage(optimized.innerId, optimized.currentOutcomePercentage);
                                  }
                                  updateIsBusinessReality(optimized.innerId, !retIsBusinessReality);
                                }}
                                disabled={!canEditAssumptions}
                              />
                            </div>
                            <span className={retIsBusinessReality ? styles.yPosHammer : styles.nPosHammer}>
                              {retIsBusinessReality ? "Yes" : "No"}
                            </span>
                          </span>
                        </div>
                      )}
                      <div className={styles.shareHeader}>
                        <div className={styles.countEditOne} title={"Subgroup"}>
                          {"Subgroup"}
                        </div>
                        <div className={styles.countEditTwo} title={"Initial State"}>
                          {"Initial State"}
                        </div>
                        {deployment && !retIsBusinessReality ? (
                          <div className={styles.countEditTwo} title={"Deployed"}>
                            {"Deployed"}
                          </div>
                        ) : (
                          ""
                        )}
                        <div
                          className={styles.countEditThree}
                          title={"Expected" + (!retIsBusinessReality ? " (New)" : "")}
                        >
                          {"Expected" + (!retIsBusinessReality ? " (New)" : "")}
                        </div>
                      </div>
                      {isOverallSegment ? (
                        <div>
                          {modelGroups && modelGroups.drilldownValues ? (
                            modelGroups.drilldownValues
                              .filter((v) => v.label !== "Overall")
                              .map((v, i) => (
                                <div className={styles.countItem} key={i}>
                                  <div className={styles.countEditOne}>{v.label}</div>
                                  <div className={styles.countEditTwo}>
                                    {Number(v.originalOutcomePercentage * 100).toFixed(2) + "%"}
                                  </div>
                                  {deployment && !retIsBusinessReality ? (
                                    <div className={styles.countEditTwo}>
                                      {Number(v.currentOutcomePercentage * 100).toFixed(2) + "%"}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <div className={styles.countEditThree}>
                                    {Number(v.outcomePercentage * 100).toFixed(2) + "%"}
                                  </div>
                                </div>
                              ))
                          ) : (
                            <div />
                          )}
                        </div>
                      ) : (
                        this.renderRecalibrateOutcomePercentage(retIsBusinessReality)
                      )}
                      <div className={styles.nHeaderHelp} style={{ marginTop: "10px" }} title={"Transaction Volume"}>
                        {"Transaction Volume"}
                      </div>
                      <div className={styles.shareHeader}>
                        <div className={styles.countEditOne} style={{ paddingLeft: "0px" }} title={"Measure"}>
                          {"Measure"}
                        </div>
                        <div
                          className={styles.countEditTwo}
                          style={{
                            textAlign: isOverallSegment || retIsBusinessReality ? "right" : "left"
                          }}
                          title={"Initial State Count"}
                        >
                          {"Initial State Count"}
                        </div>
                        {deployment && !retIsBusinessReality ? (
                          <div
                            className={styles.countEditTwo}
                            style={{
                              textAlign: isOverallSegment || retIsBusinessReality ? "right" : "left"
                            }}
                            title={"Deployed Count"}
                          >
                            {"Deployed Count"}
                          </div>
                        ) : (
                          ""
                        )}
                        <div
                          className={styles.countEditThree}
                          style={{
                            paddingRight: "0px",
                            textAlign: isEditCounts ? "left" : "right"
                          }}
                          title={"Expected Count" + (!retIsBusinessReality ? " (New)" : "")}
                        >
                          {"Expected Count" + (!retIsBusinessReality ? " (New)" : "")}
                        </div>
                      </div>
                      {isOverallSegment || retIsBusinessReality === true ? (
                        <div>
                          <div className={styles.countItem}>
                            <div className={styles.countEditOne}>{optimized.setup.truePositiveLabel}</div>
                            <div className={styles.countEditTwo}>{optimized.originalSetup.truePositive}</div>
                            <div className={styles.countEditThree}>{optimized.setup.truePositive}</div>
                          </div>
                          <div className={styles.countItem}>
                            <div className={styles.countEditOne}>{optimized.setup.falsePositiveLabel}</div>
                            <div className={styles.countEditTwo}>{optimized.originalSetup.falsePositive}</div>
                            <div className={styles.countEditThree}>{optimized.setup.falsePositive}</div>
                          </div>
                          <div className={styles.countItem}>
                            <div className={styles.countEditOne}>{optimized.setup.trueNegativeLabel}</div>
                            <div className={styles.countEditTwo}>{optimized.originalSetup.trueNegative}</div>
                            <div className={styles.countEditThree}>{optimized.setup.trueNegative}</div>
                          </div>
                          <div className={styles.countItem}>
                            <div className={styles.countEditOne}>{optimized.setup.falseNegativeLabel}</div>
                            <div className={styles.countEditTwo}>{optimized.originalSetup.falseNegative}</div>
                            <div className={styles.countEditThree}>{optimized.setup.falseNegative}</div>
                          </div>
                          <div className={styles.countItem}>
                            <div className={styles.countEditOne}>{"Total Population"}</div>
                            <div className={styles.countEditTwo}>
                              {Number(optimized.originalSetup.truePositive) +
                                Number(optimized.originalSetup.falsePositive) +
                                Number(optimized.originalSetup.trueNegative) +
                                Number(optimized.originalSetup.falseNegative)}
                            </div>
                            <div className={styles.countEditThree}>
                              {Number(optimized.setup.truePositive) +
                                Number(optimized.setup.falsePositive) +
                                Number(optimized.setup.trueNegative) +
                                Number(optimized.setup.falseNegative)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div className={styles.countEditItem}>
                            <div className={styles.countEditOne}>{optimized.setup.truePositiveLabel}</div>
                            <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                              {optimized.originalSetup.truePositive}
                            </div>
                            {deployment && !retIsBusinessReality ? (
                              <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                                {optimized.deployedSetup.truePositive}
                              </div>
                            ) : (
                              ""
                            )}
                            <div className={styles.countEditThree}>
                              <LineInput
                                isMediumBox
                                value={optimized.setup.truePositive}
                                onChange={(val) => updateTruePositive(optimized.innerId, val)}
                              />
                            </div>
                          </div>
                          <div className={styles.countEditItem}>
                            <div className={styles.countEditOne}>{optimized.setup.falsePositiveLabel}</div>
                            <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                              {optimized.originalSetup.falsePositive}
                            </div>
                            {deployment && !retIsBusinessReality ? (
                              <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                                {optimized.deployedSetup.falsePositive}
                              </div>
                            ) : (
                              ""
                            )}
                            <div className={styles.countEditThree}>
                              <LineInput
                                isMediumBox
                                value={optimized.setup.falsePositive}
                                onChange={(val) => updateFalsePositive(optimized.innerId, val)}
                              />
                            </div>
                          </div>
                          <div className={styles.countEditItem}>
                            <div className={styles.countEditOne}>{optimized.setup.trueNegativeLabel}</div>
                            <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                              {optimized.originalSetup.trueNegative}
                            </div>
                            {deployment && !retIsBusinessReality ? (
                              <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                                {optimized.deployedSetup.trueNegative}
                              </div>
                            ) : (
                              ""
                            )}
                            <div className={styles.countEditThree}>
                              <LineInput
                                isMediumBox
                                value={optimized.setup.trueNegative}
                                onChange={(val) => updateTrueNegative(optimized.innerId, val)}
                              />
                            </div>
                          </div>
                          <div className={styles.countEditItem}>
                            <div className={styles.countEditOne}>{optimized.setup.falseNegativeLabel}</div>
                            <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                              {optimized.originalSetup.falseNegative}
                            </div>
                            {deployment && !retIsBusinessReality ? (
                              <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                                {optimized.deployedSetup.falseNegative}
                              </div>
                            ) : (
                              ""
                            )}
                            <div className={styles.countEditThree}>
                              <LineInput
                                isMediumBox
                                value={optimized.setup.falseNegative}
                                onChange={(val) => updateFalseNegative(optimized.innerId, val)}
                              />
                            </div>
                          </div>
                          <div className={styles.countEditItem}>
                            <div className={styles.countEditOne}>{"Total Population"}</div>
                            <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                              {optimized.originalSetup
                                ? Number(optimized.originalSetup.truePositive) +
                                  Number(optimized.originalSetup.falsePositive) +
                                  Number(optimized.originalSetup.trueNegative) +
                                  Number(optimized.originalSetup.falseNegative)
                                : "N/A"}
                            </div>
                            {deployment && !retIsBusinessReality ? (
                              <div className={styles.countEditTwo} style={{ textAlign: "left" }}>
                                {optimized.deployedSetup
                                  ? Number(optimized.deployedSetup.truePositive) +
                                    Number(optimized.deployedSetup.falsePositive) +
                                    Number(optimized.deployedSetup.trueNegative) +
                                    Number(optimized.deployedSetup.falseNegative)
                                  : "N/A"}
                              </div>
                            ) : (
                              ""
                            )}
                            <div className={styles.countEditThree}>
                              <LineInput
                                isMediumBox
                                value={scaledTotal}
                                onChange={(val) => updateScaledTotal(optimized.innerId, Number(val))}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={styles.nItemBotHelp + " " + styles.collabWindow}>
                      <div className={styles.nHeaderHelp + " " + styles.collab}>
                        {"Collaboration"}
                        <div className={styles.hSelect}>
                          {canManageSegmentPermissions ? (
                            <Button
                              active={isSharing}
                              style={{ padding: "5px" }}
                              onClick={() => {
                                updateProjectSetting("isSharing", !isSharing);
                                updateProjectSetting("isAFO", false);
                                this.setState({
                                  isAssumptions: false
                                });
                              }}
                            >
                              {"Edit Collaborators"}
                            </Button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className={styles.nHelp}>
                        {isOverallSegment ? (
                          <div className={styles.shareHeader}>
                            <div className={styles.sHeaderOne}>{"Subgroup"}</div>
                            <div className={styles.sheaderTwo}>{"Collaborators"}</div>
                          </div>
                        ) : (
                          <div className={styles.shareHeader}>
                            <div className={styles.sHeaderOne}>{"Name"}</div>
                            <div className={styles.sheaderTwo}>{"Pending Edits"}</div>
                          </div>
                        )}
                        {isOverallSegment
                          ? project.segments
                              .filter((s, i) => i > 0)
                              .sort((a, b) =>
                                a.conditions &&
                                b.conditions &&
                                a.conditions.length > 0 &&
                                b.conditions.length > 0 &&
                                b.conditions[0].value < a.conditions[0].value
                                  ? 1
                                  : -1
                              )
                              .map((s) => this.renderSharingSegment(s))
                          : this.renderSharingSegment(optimized.innerSegment)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.overallBody}></div>
      </div>
    );
  }

  renderAssumptionItem(setup, assSetup, labelKey, valueKey, countKey, forceLabel = undefined) {
    const { optimized } = this.props;

    const label = forceLabel ? forceLabel : setup[labelKey];
    const value = setup[valueKey];
    const oldValue = assSetup ? assSetup[valueKey] : value;
    const count = setup[countKey];
    const oldCount = assSetup ? assSetup[countKey] : count;

    const isValueDifferent = Number(value) !== Number(oldValue);
    const isCountDifferent = Number(count) !== Number(oldCount);

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    return (
      <div className={styles.oSlice}>
        <div className={styles.oBodyItem}>
          <div className={styles.oBodyItemLabel} title={label}>
            {label + ":"}
          </div>
          <div
            className={isValueDifferent ? styles.oBodyItemContentChange : styles.oBodyItemContent}
            title={isValueDifferent ? `Changed from ${oldValue} to ${value}` : value}
          >
            {`${value}${isValueDifferent ? "*" : ""}`}
          </div>
        </div>
        {isContinuous ? (
          <div />
        ) : (
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div
              className={isCountDifferent ? styles.oBodyItemContentChange : styles.oBodyItemContent}
              title={isCountDifferent ? `Changed from ${oldCount} to ${count}` : value}
            >
              {`${count}${isCountDifferent ? "*" : ""}`}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderCustomAssumptionItem(setup, assSetup, customKey) {
    const label = customKey;
    const value = setup.customValues[customKey];
    const oldValue = assSetup ? assSetup.customValues[customKey] : value;

    const isValueDifferent = Number(value) !== Number(oldValue);

    return (
      <div className={styles.oSlice} key={label}>
        <div className={styles.oBodyItem}>
          <div className={styles.oBodyItemLabel} title={label}>
            {label + ":"}
          </div>
          <div
            className={isValueDifferent ? styles.oBodyItemContentChange : styles.oBodyItemContent}
            title={isValueDifferent ? `Changed from ${oldValue} to ${value}` : value}
          >
            {`${value}${isValueDifferent ? "*" : ""}`}
          </div>
        </div>
      </div>
    );
  }

  renderAssumptionsSetup(setup, assSetup = undefined) {
    const { optimized } = this.props;

    const isContinuous =
      optimized &&
      optimized.bestModel &&
      optimized.bestModel.metrics &&
      optimized.bestModel.metrics.overImpact !== undefined &&
      optimized.bestModel.metrics.underImpact !== undefined;

    return (
      <div className={styles.assumptionBody}>
        {setup &&
          setup.customValues &&
          Object.keys(setup.customValues).map((c) => this.renderCustomAssumptionItem(setup, assSetup, c))}
        {isContinuous ? (
          <div>
            {this.renderAssumptionItem(
              setup,
              assSetup,
              "truePositiveLabel",
              "conversionGain",
              "truePositive",
              "Overestimate"
            )}
            {this.renderAssumptionItem(
              setup,
              assSetup,
              "falsePositiveLabel",
              "conversionCost",
              "falsePositive",
              "Underestimate"
            )}
          </div>
        ) : (
          <div>
            {this.renderAssumptionItem(setup, assSetup, "truePositiveLabel", "conversionGain", "truePositive")}
            {this.renderAssumptionItem(setup, assSetup, "falsePositiveLabel", "conversionCost", "falsePositive")}
            {this.renderAssumptionItem(setup, assSetup, "trueNegativeLabel", "conversionSaved", "trueNegative")}
            {this.renderAssumptionItem(setup, assSetup, "falseNegativeLabel", "conversionMissed", "falseNegative")}
          </div>
        )}
      </div>
    );
  }

  renderAssumptions() {
    const {
      optimizer,
      optimized,
      modelGroups,
      resetCosts,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateTruePositive,
      updateTrueNegative,
      updateFalsePositive,
      updateFalseNegative
    } = this.props;

    return (
      <div className={styles.oBodySection}>
        <div className={styles.oBodyHeader}>{"Approved"}</div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.truePositiveLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionGain}
                onChange={(val) => updateConversionGain(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.truePositive}
                onChange={(val) => updateTruePositive(optimized.id, val)}
              />
            </div>
          </div>
        </div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.falsePositiveLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionCost}
                onChange={(val) => updateConversionCost(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.falsePositive}
                onChange={(val) => updateFalsePositive(optimized.id, val)}
              />
            </div>
          </div>
        </div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.trueNegativeLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionSaved}
                onChange={(val) => updateConversionSaved(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.trueNegative}
                onChange={(val) => updateTrueNegative(optimized.id, val)}
              />
            </div>
          </div>
        </div>
        <div className={styles.oSlice}>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel}>{optimized.setup.falseNegativeLabel + ":"}</div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.conversionMissed}
                onChange={(val) => updateConversionMissed(optimized.id, val)}
              />
            </div>
          </div>
          <div className={styles.oBodyItem}>
            <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
              {"Count:"}
            </div>
            <div className={styles.oBodyItemContent}>
              <LineInput
                isMediumBox
                isDark
                value={optimized.setup.falseNegative}
                onChange={(val) => updateFalseNegative(optimized.id, val)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderRightPanel() {
    const {
      optimizer,
      optimized,
      modelGroups,
      resetCosts,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateTruePositive,
      updateTrueNegative,
      updateFalsePositive,
      updateFalseNegative
    } = this.props;
    const { isRightOpen } = this.state;

    return (
      <div className={styles.rightPanel + " " + (isRightOpen ? styles.rightOpen : "")}>
        <div className={styles.rightHeader}>{"Impacts"}</div>
        <div className={styles.rightContent}>
          {optimized && optimized && optimized.setup && (
            <div className={styles.oBodySection}>
              <div className={styles.oBodyHeader}>{"Marketing"}</div>
              <div>{optimized.setup.label}</div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.truePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionGain}
                      onChange={(val) => updateConversionGain(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.truePositive}
                      onChange={(val) => updateTruePositive(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.falsePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionCost}
                      onChange={(val) => updateConversionCost(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.falsePositive}
                      onChange={(val) => updateFalsePositive(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.trueNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionSaved}
                      onChange={(val) => updateConversionSaved(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.trueNegative}
                      onChange={(val) => updateTrueNegative(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.setup.falseNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.conversionMissed}
                      onChange={(val) => updateConversionMissed(optimized.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.setup.falseNegative}
                      onChange={(val) => updateFalseNegative(optimized.id, val)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {optimized && optimized.second && optimized.second.setup && (
            <div className={styles.oBodySection}>
              <div className={styles.oBodyHeader}>{"Sales"}</div>
              <div>{optimized.second.setup.label}</div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.truePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionGain}
                      onChange={(val) => updateConversionGain(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.truePositive}
                      onChange={(val) => updateTruePositive(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.falsePositiveLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionCost}
                      onChange={(val) => updateConversionCost(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.falsePositive}
                      onChange={(val) => updateFalsePositive(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.trueNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionSaved}
                      onChange={(val) => updateConversionSaved(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.trueNegative}
                      onChange={(val) => updateTrueNegative(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.oSlice}>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel}>{optimized.second.setup.falseNegativeLabel + ":"}</div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.conversionMissed}
                      onChange={(val) => updateConversionMissed(optimized.second.id, val)}
                    />
                  </div>
                </div>
                <div className={styles.oBodyItem}>
                  <div className={styles.oBodyItemLabel} style={{ width: "60px" }}>
                    {"Count:"}
                  </div>
                  <div className={styles.oBodyItemContent}>
                    <LineInput
                      isMediumBox
                      isDark
                      value={optimized.second.setup.falseNegative}
                      onChange={(val) => updateFalseNegative(optimized.second.id, val)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSubControls() {
    const { optimizer, optimized, setMarketingBudget, setSalesBudget, setOverallScaleFromRowCount } = this.props;
    const { mode, timePeriod, prospects, mBudget, sStaffing, leads, wins } = this.state;

    return (
      <div className={styles.tHeader}>
        {/*
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Time Period"}</div>
          <div className={styles.tInput}>
            <Select
              options={[
                { value: "Day", label: "Day" },
                { value: "Week", label: "Week" },
                { value: "Month", label: "Month" },
                { value: "Quarter", label: "Quarter" },
                { value: "Year", label: "Year" }
              ]}
              value={timePeriod}
              onChange={val => this.setState({ timePeriod: val })}
              className={styles.tSelect}
            />
          </div>
          <div className={styles.tSub}></div>
        </div>
      */}
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Marketing Budget"}</div>
          <div className={styles.tInput}>
            <LineInput isMediumBox isDark defaultValue={optimized.budget} onChange={(val) => setMarketingBudget(val)} />
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Sales Budget"}</div>
          <div className={styles.tInput}>
            <LineInput
              isMediumBox
              isDark
              defaultValue={optimized.second.budget}
              onChange={(val) => setSalesBudget(val)}
            />
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Total Prospects"}</div>
          <div className={styles.tInput}>
            <LineInput
              isMediumBox
              isDark
              defaultValue={optimized.totalProspects}
              onChange={(val) => setOverallScaleFromRowCount(val)}
            />
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem}>
          <div className={styles.tTitle}>{"Marketing Qualified Leads"}</div>
          <div className={styles.tInput}>
            <NumericLabel params={numberFormatParams}>{optimized.totalWon}</NumericLabel>
          </div>
          <div className={styles.tSub}></div>
        </div>
        <div className={styles.tItem} style={{ borderRight: "0px" }}>
          <div className={styles.tTitle}>{"Wins"}</div>
          <div className={styles.tInput}>
            <NumericLabel params={numberFormatParams}>{optimized.second.totalWon}</NumericLabel>
          </div>
          <div className={styles.tSub}></div>
        </div>
      </div>
    );
  }

  renderDrilldown() {
    const { optimizer, optimized, setMarketingBudget, setSalesBudget, modelGroups } = this.props;
    const { mode, timePeriod, prospects, mBudget, sStaffing, leads, wins } = this.state;

    return (
      <div className={styles.drilldown}>
        {/* this.renderSubControls() */}
        <div className={styles.sHeader}>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Marketing Spend"}</div>
            <div className={styles.sHero}>
              {(optimized.totalCost < 0 ? "-" : "") + optimized.unitLabelShort}
              <NumericLabel params={numberFormatParams}>{Math.abs(optimized.totalCost)}</NumericLabel>
            </div>
          </div>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Per Lead Cost"}</div>
            <div className={styles.sHero}>
              {(optimized.totalCost < 0 ? "-" : "") + optimized.unitLabelShort}
              <NumericLabel params={numberFormatParams}>{Math.abs(optimized.setup.conversionCost)}</NumericLabel>
            </div>
          </div>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Expected Leads"}</div>
            <div className={styles.sHero}>{Math.round(optimized.totalWon)}</div>
          </div>
          <div className={styles.sItem}>
            <div className={styles.sTitle}>{"Sales Expense"}</div>
            <div className={styles.sHero}>
              {(optimized.second.totalCost < 0 ? "-" : "") + optimized.unitLabelShort}
              <NumericLabel params={numberFormatParams}>{Math.abs(optimized.second.totalCost)}</NumericLabel>
            </div>
          </div>
          <div className={styles.sItem} style={{ marginRight: "350px" }}>
            <div className={styles.sTitle}>{"Wins"}</div>
            <div className={styles.sHero}>{Math.round(optimized.second.totalWon)}</div>
          </div>
        </div>
        <div className={styles.oBody}>
          {<SankeyChart optimized={optimized} />}
          {this.renderProfitBox(
            {
              marginTop: "0px",
              marginBottom: "575px",
              textAlign: "center",
              whiteSpace: "nowrap",
              marginRight: "20px",
              marginLeft: "-50px",
              zIndex: "2"
            },
            true
          )}
        </div>
      </div>
    );
  }
}
